webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(75);







var DEV_ENV = 'https://yunfront.dev.aiyaopai.com';
var PRO_ENV = '//yunfront.aiyaopai.com';

var DOMAIN = DEV_ENV;

if (window.location.hostname === 'yun.aiyaopai.com' || window.location.hostname === 'yun.aiyaopai.com' || window.location.hostname === 'yun-src.aiyaopai.com') {
  DOMAIN = PRO_ENV;
} else {
  DOMAIN = DEV_ENV;
}

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.withCredentials = true;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

var api = {
  live: {
    combinePicture: 'PublishPicture.Combine',
    getPhotoDetail: 'PublishPicture.Get',
    getLiveDetail: 'Activity.Get',
    getPhotoList: 'PublishPicture.Search',
    fetchCategory: 'PublishPictureCategory.All',
    faceRecog: 'PublishPicture.SearchFace',
    getLivePushUrl: 'Activity.GetLivePushUrl',
    addViewCount: 'Activity.AddViewCount' },
  user: {
    signInWithWeChat: 'User.SignInWithWeChat',
    currentUser: 'User.CurrentUser' },
  common: {
    getQiniuToken: 'Interact.StorageToken' },
  interaction: {
    publishInteraction: 'Interact.Insert',
    getInteractionList: 'Interact.Search',
    getInteractionDetail: 'Interact.Get',
    getInteractionLikeList: 'Interact.LikedUserSearch',
    getInteractionCommentList: 'InteractComment.Search',
    unLike: 'Interact.UnLike',
    like: 'Interact.Like',
    checkLike: 'Interact.LikedExists',
    addComment: 'InteractComment.Insert',
    delete: 'Interact.Delete' }
};

var getPhotoDetail = function getPhotoDetail(pId) {
  var data = {
    api: api.live.getPhotoDetail,
    id: pId,
    fields: 'ActivityId,Ave,Height,Id,IsLarge,OriginalAt,Size,Title,Url,Width'
  };
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res.status == 200) {
        resolve(res.data);
      }
    }).catch(function (err) {
      reject(err);
    });
  });
};

var addViewCount = function addViewCount(liveId) {
  var data = {
    api: api.live.addViewCount,
    id: liveId
  };
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res.status == 200) {
        resolve(res.data);
      }
    }).catch(function (err) {
      reject(err);
    });
  });
};

var fetchCategory = function fetchCategory(activityId) {
  var data = {
    activityId: activityId,
    fields: 'Id,Name,ActivityId,OrderNumber'
  };
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(DOMAIN + '?api=' + api.live.fetchCategory, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res.status == 200) {
        resolve(res.data);
      }
    }).catch(function (err) {
      console.log(err.response);
      reject(err);
    });
  });
};

var combinePicture = function combinePicture(ids, liveId) {
  var data = {
    api: api.live.combinePicture,
    ids: ids,
    activityId: liveId
  };

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res.status == 200) {
        resolve(res.data);
      }
    }).catch(function (err) {
      console.log(err.response);
      reject(err);
    });
  });
};

var getLivePushUrl = function getLivePushUrl(url) {
  var data = {
    pushId: url
  };
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(DOMAIN + '?api=' + api.live.getLivePushUrl, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(function (err) {
      console.log('异常信息：', err.response);
    });
  });
};

var getLiveDetail = function getLiveDetail(liveId, router, cb) {
  var data = {
    id: liveId,
    fields: 'Id,LargePictureSeparatedEnabled,Title,SubTitle,ViewsEnable,JigsawEnabled,BannerExternalName,EncryptEnabled,EncryptPassword,LivePushStreamUrl,LivePullStreamUrl,LiveEnabled,FaceEnabled,Watermark,BannerVideo,SubscribeDisabled,BannerExternalVideoUrl,ShareLogo,Banner,LoadingImage,FlashScreenImage,ViewC' + 'ount,PublishPicturesCount,SponsorTitle,CopyrightDisplay,DescriptionTitle,BeginAt' + ',EndAt,Address,Description,Sponsors.Name,Sponsors.QrCode,Sponsors.Id,Sponsors.De' + 'scription,Sponsors.Logo,Logo,ParticipatorDisabled,InteractDisabled'
  };

  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(DOMAIN + '?api=' + api.live.getLiveDetail, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (res) {
    cb(res);
  }).catch(function (err) {
    router.push({
      name: 'error',
      query: {
        code: err.response.data.Code,
        message: err.response.data.Message
      }
    });
  });
};

var faceRecog = function faceRecog(liveId, url) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      activityId: liveId,
      url: url,
      fields: 'Id,Width,Height,UpdatedAt,Title,IsLarge,OriginalAt,Size,Url,CategoryId'
    };
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(DOMAIN + '?api=' + api.live.faceRecog, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res) {
        resolve(res);
      }
    }).catch(function (err) {
      reject(err.response);
    });
  });
};

var getPhotoList = function getPhotoList(args, cb) {
  var data = {
    IsLarge: args.option.isLarge,
    categoryId: args.option.categoryId,
    activityId: args.option.liveId,
    pageSize: args.option.pageSize,
    pageIndex: args.option.pageIndex,
    fields: 'Id,ActivityId,Url,Width,Height,IsLarge,Title,OriginalAt,Size,Ave'
  };

  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(DOMAIN + '?api=' + api.live.getPhotoList, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (res) {
    cb(res);
  }).catch(function (err) {
    console.log(err.response);
  });
};

var signInWithWeChat = function signInWithWeChat(refresh_token, cb) {
  var data = {
    api: api.user.signInWithWeChat,
    refreshToken: refresh_token
  };
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (res) {
    cb(res);
  }).catch(function (err) {
    console.log(err.response);
  });
};

var getCurrentUser = function getCurrentUser(cb) {
  var data = {
    api: api.user.currentUser,
    fields: 'Id,Nickname,Avatar'
  };
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (res) {
    cb(res);
  }).catch(function (err) {
    console.log('捕获的错误1：', err.response);
    cb(err);
  });
};

var getQiniuToken = function getQiniuToken(cb) {
  var data = {
    api: api.common.getQiniuToken
  };
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      resolve(res);
    }).catch(function (err) {
      reject(err);
    });
  });
};

var getInteractionList = function getInteractionList(activityId, pageIndex, pageSize, userId) {
  var data = {};
  if (userId) {
    data = {
      api: api.interaction.getInteractionList,
      fields: 'Id,CreatedAt,Title,LikesCount,Picture,UserId,User.Nickname,User.Avatar',
      pageSize: pageSize,
      pageIndex: pageIndex,
      activityId: activityId,
      userId: userId
    };
  } else {
    data = {
      api: api.interaction.getInteractionList,
      fields: 'Id,CreatedAt,Title,LikesCount,Picture,UserId,User.Nickname,User.Avatar',
      pageSize: pageSize,
      pageIndex: pageIndex,
      activityId: activityId
    };
  }

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res.status == 200) {
        resolve(res);
      }
    }).catch(function (err) {
      reject(err);
      console.log(err.response);
    });
  });
};

var publishInteraction = function publishInteraction(title, picture, activityId, cb) {
  var data = {
    api: api.interaction.publishInteraction,
    title: title,
    picture: picture,
    activityId: activityId
  };

  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (res) {
    cb(res);
  }).catch(function (err) {
    console.log(err.response);
  });
};

var getInteractionDetail = function getInteractionDetail(id, cb) {
  var data = {
    api: api.interaction.getInteractionDetail,
    id: id,
    fields: 'Id,CreatedAt,Picture,Title,LikesCount,ActivityId,UserId,User.Nickname,User.Avata' + 'r'
  };
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (res) {
    cb(res);
  }).catch(function (err) {
    console.log(err.response);
  });
};

var getInteractionLikeList = function getInteractionLikeList(id, pageIndex, pageSize) {
  var data = {
    api: api.interaction.getInteractionLikeList,
    fields: 'Id,CreatedAt,Nickname,Avatar',
    pageIndex: pageIndex,
    pageSize: pageSize,
    interactId: id
  };

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      resolve(res);
    }).catch(function (err) {
      reject(err);
      console.log(err.response);
    });
  });
};

var getInteractionCommentList = function getInteractionCommentList(id, pageIndex, pageSize) {
  var data = {
    api: api.interaction.getInteractionCommentList,
    fields: 'Id,CreatedAt,User.Nickname,User.Avatar,Content,UserId',
    pageIndex: pageIndex,
    pageSize: pageSize,
    interactId: id
  };

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      resolve(res);
    }).catch(function (err) {
      reject(err);
      console.log(err.response);
    });
  });
};

var unLike = function unLike(id) {
  var data = {
    api: api.interaction.unLike,
    interactId: id
  };

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res.status == 200) {
        if (res.data.Success) {
          resolve();
        }
      }
    }).catch(function (err) {
      reject(err);
      console.log(err.response);
    });
  });
};

var like = function like(id) {
  var data = {
    api: api.interaction.like,
    interactId: id
  };

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res.status == 200) {
        if (res.data.Success) {
          resolve();
        }
      }
    }).catch(function (err) {
      console.log(err.response);
    });
  });
};

var addComment = function addComment(id, content) {
  var data = {
    api: api.interaction.addComment,
    content: content,
    interactId: id
  };

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res.status == 201) {
        if (res.data.Id) {
          resolve(res.data.Id);
        }
      }
    }).catch(function (err) {
      reject(err);
      console.log(err.response);
    });
  });
};

var removeInteraction = function removeInteraction(id) {
  var data = {
    api: api.interaction.delete,
    id: id
  };

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res.status == 200) {
        if (res.data.Success) {
          resolve();
        }
      }
    }).catch(function (err) {
      reject(err);
      console.log(err.response);
    });
  });
};

var checkLike = function checkLike(UID, IID) {
  var data = {
    api: api.interaction.checkLike,
    UserId: UID,
    interactId: IID
  };

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + DOMAIN, __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (res) {
      if (res.status == 200) {
        resolve(res.data.Result);
      }
    }).catch(function (err) {
      reject(err);
      console.log(err.response);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  live: {
    combinePicture: combinePicture,
    getPhotoDetail: getPhotoDetail,
    addViewCount: addViewCount,
    getLivePushUrl: getLivePushUrl,
    fetchCategory: fetchCategory,
    faceRecog: faceRecog,
    getLiveDetail: getLiveDetail,
    getPhotoList: getPhotoList,
    publishInteraction: publishInteraction,
    getInteractionList: getInteractionList,
    getInteractionDetail: getInteractionDetail,
    getInteractionLikeList: getInteractionLikeList,
    getInteractionCommentList: getInteractionCommentList,
    removeInteraction: removeInteraction,
    like: like,
    unLike: unLike,
    checkLike: checkLike,
    addComment: addComment
  },
  user: {
    signInWithWeChat: signInWithWeChat,
    getCurrentUser: getCurrentUser
  },
  base: {
    getQiniuToken: getQiniuToken
  }
});

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return live; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return base; });

var live = {
  getLiveDetail: 'GET_LIVE_DETAIL',
  getPhotoList: 'GET_PHOTO_LIST',
  setPageIndex: 'SET_PAGEINDEX',
  getInteractionList: 'GET_INTERACTION_LIST',
  getInteractionDetail: 'GET_INTERACTION_DETAIL',
  getInteractionListByUserId: 'GET_INTERACTION_LIST_BY_USERID',
  getLargePhotoList: 'GET_LARGE_PHOTO_LIST',
  getFaceList: 'GET_FACE_LIST' };

var user = {
  getCurrentUser: 'GET_CURRENT_USER' };

var base = {
  setView: 'SET_VIEW',
  getQiniuToken: 'GET_QINIU_TOKEN' };

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(397)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(499),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(416)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(519),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(430)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(417)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(520),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(436)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Error__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_live_Index__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_live_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_live_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_live_HotView__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_live_HotView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_live_HotView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_live_LiveDetail__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_live_LiveDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_live_LiveDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_live_Interaction__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_live_Interaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_live_Interaction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_live_InteractionPublish__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_live_InteractionPublish___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_live_InteractionPublish__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_live_FaceRecogPage__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_live_FaceRecogPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_live_FaceRecogPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_user_Index__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_user_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_user_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Login_Login__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_user_UserDetail__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_user_UserDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_user_UserDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_user_Interaction__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_user_Interaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_user_Interaction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_user_InteractionDetail__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_user_InteractionDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_user_InteractionDetail__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Home___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      next(false);
      window.location.href = 'https://yun.aiyaopai.com/static/home/index.html';
    },
    meta: {
      requireAuth: false
    }
  }, {
    path: '/error',
    name: 'error',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Error___default.a,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/live',
    name: 'liveIndex',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_live_Index___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      next(false);
      window.location.href = 'https://yun.aiyaopai.com/static/home/index.html';
    },
    meta: {
      requireAuth: false
    }
  }, {
    path: '/live/:liveId',
    name: 'liveDetail',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_live_LiveDetail___default.a,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/live/:liveId/interaction',
    name: 'liveInteraction',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_live_Interaction___default.a,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/live/:liveId/hotview',
    name: 'hotView',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_live_HotView___default.a,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/live/:liveId/faceRecog',
    name: 'FaceRecogPage',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_live_FaceRecogPage___default.a,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/live/:liveId/interaction/publish',
    name: 'liveInteractionPublish',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_live_InteractionPublish___default.a,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/login',
    name: 'userLogin',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Login_Login___default.a,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/live/:liveId/user',
    name: 'userIndex',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_user_Index___default.a,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/live/:liveId/user/:interactionId',
    name: 'userInteractionDetail',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_user_InteractionDetail___default.a,
    meta: {
      requireAuth: true
    }
  }]
}));

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(394)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(494),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(426)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(411)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(514),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(496),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(412)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(515),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(398)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(500),
  /* scopeId */
  "data-v-2284d37c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(435)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  "data-v-e3de3b94",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(498),
  /* scopeId */
  "data-v-2139a6bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(413)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(516),
  /* scopeId */
  "data-v-5a3b77d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_live__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_base__ = __webpack_require__(277);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    live: __WEBPACK_IMPORTED_MODULE_2__modules_live__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    base: __WEBPACK_IMPORTED_MODULE_4__modules_base__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scroller__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_video_player__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_loading_index_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_plugins_toast_index_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_alert_index_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_store__ = __webpack_require__(248);
















__webpack_require__(252);
__webpack_require__(253);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vux_src_plugins_toast_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_loading_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_scroller___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_alert_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_video_player___default.a);

__WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].beforeEach(function (to, from, next) {
  var user = JSON.parse(window.localStorage.getItem('user'));
  var validDate = window.localStorage.getItem('validDate');
  if (to.matched.some(function (record) {
    return record.meta.requireAuth;
  })) {
    if (!user || !validDate) {
      window.localStorage.to = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(to);
      login();
      return false;
    }

    if (new Date().getTime() - new Date(validDate).getTime() > 3600000) {
      window.localStorage.removeItem('user');
      window.localStorage.removeItem('validDate');
      window.localStorage.to = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(to);
      login();
      return false;
    }
    next();
  } else {
    next();
  }
});

function login() {
  var redUrl = encodeURI(window.location.origin + '/login');
  var url = 'https://wechatauth.aiyaopai.com/auth/clientside?appid=wx76b9a692b8709d44&redirect_uri=' + redUrl + '&response_type=code&scope=snsapi_userinfo&state=21';
  window.location.href = url;
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_11__store_store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_9__App___default.a);
  }
}).$mount('#app-box');

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(6);



var _mutations;




var state = {
  viewHeight: 0,
  viewWidth: 0,
  qiniuToken: ''
};

var getters = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* base */].setView, function (state, data) {
  state.viewHeight = data.viewHeight;
  state.viewWidth = data.viewWidth;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* base */].getQiniuToken, function (state, data) {
  state.qiniuToken = data.Token;
}), _mutations);

var actions = {
  getQiniuToken: function getQiniuToken(context) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].base.getQiniuToken().then(function (res) {
        if (res) {
          context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* base */].getQiniuToken, res.data);
          resolve();
        }
      }).catch(function (err) {
        console.log('========err', err.response);
        reject(err);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(6);



var _mutations;




var state = {
  detail: {
    BeginAt: '',
    EndAt: ''
  },
  faceList: [],
  photoList: [],
  totalNum: 0,
  hotTotalNum: 0,
  largePhotoList: [],
  hotPageIndex: 1,
  pageIndex: 1,
  interactionList: [],
  interactionDetail: {},
  currentUserInteractionList: []
};

var getters = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getLiveDetail, function (state, res) {
  state.detail = res;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getPhotoList, function (state, res) {
  state.loadState = true;
  if (state.pageIndex == 1) {
    state.photoList = [];
  }
  state.photoList = state.photoList.concat(res.Result);
  state.totalNum = res.Total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getLargePhotoList, function (state, res) {
  state.hotLoadState = true;
  if (state.hotPageIndex == 1) {
    state.largePhotoList = [];
  }
  state.largePhotoList = state.largePhotoList.concat(res.Result);
  state.hotTotalNum = res.Total;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].setPageIndex, function (state, res) {
  state.pageIndex = res.index;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getInteractionList, function (state, res) {
  state.interactionList = res;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getFaceList, function (state, res) {
  state.faceList = res;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getInteractionDetail, function (state, res) {
  state.interactionDetail = res;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getInteractionListByUserId, function (state, res) {
  state.currentUserInteractionList = res;
}), _mutations);

var actions = {
  getFaceList: function getFaceList(context, data) {
    console.log('come in getFaceList action');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.faceRecog(data.liveId, data.url).then(function (res) {
        if (res) {
          context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getFaceList, res.data);
          resolve();
        }
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getLiveDetail: function getLiveDetail(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.getLiveDetail(data.liveId, data.router, function (res) {
        if (res) {
          context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getLiveDetail, res.data);
          resolve();
        } else {
          console.log('网络异常');
          reject();
        }
      });
    });
  },
  getPhotoList: function getPhotoList(context, args) {
    __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.getPhotoList(args, function (res) {
      if (res) {
        context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getPhotoList, res.data);
      } else {
        console.log('网络异常');
      }
    });
  },
  getLargePhotoList: function getLargePhotoList(context, args) {

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.getPhotoList(args, function (res) {

        if (res) {
          context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getLargePhotoList, res.data);
          resolve();
        } else {
          console.log('网络异常');
          reject();
        }
      });
    });
  },
  getInteractionList: function getInteractionList(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var itList = [];

      var likeRes = {};

      var commentRes = {};

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.getInteractionList(data.liveId, data.pageIndex, data.pageSize).then(function (list) {
        itList = list.data;

        var promiseArr = [];
        list.data.Result.map(function (item) {
          promiseArr.push(__WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.getInteractionLikeList(item.Id, 1, 22));
        });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promiseArr);
      }).then(function (likeList) {
        likeRes = likeList;

        var newPromiseArr = [];
        itList.Result.map(function (item) {
          newPromiseArr.push(__WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.getInteractionCommentList(item.Id, 1, 10));
        });

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(newPromiseArr);
      }).then(function (commentList) {
        commentRes = commentList;
        itList.Result.map(function (interact, i) {
          interact.isLiked = false;

          interact.likeInfo = likeRes[i];
          interact.commentInfo = commentRes[i];

          __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.checkLike(JSON.parse(window.localStorage.user).Id, interact.Id).then(function (res) {
            interact.isLiked = res;
          });
        });

        context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getInteractionList, itList);
        resolve();
      });
    });
  },
  getUserInteractionList: function getUserInteractionList(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var itList = [];

      var likeRes = {};

      var commentRes = {};

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.getInteractionList(data.liveId, data.pageIndex, data.pageSize, data.userId).then(function (list) {
        itList = list.data;

        var promiseArr = [];
        list.data.Result.map(function (item) {
          promiseArr.push(__WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.getInteractionLikeList(item.Id, 1, 22));
        });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promiseArr);
      }).then(function (likeList) {
        likeRes = likeList;

        var newPromiseArr = [];
        itList.Result.map(function (item) {
          newPromiseArr.push(__WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.getInteractionCommentList(item.Id, 1, 10));
        });

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(newPromiseArr);
      }).then(function (commentList) {
        commentRes = commentList;
        itList.Result.map(function (interact, i) {
          interact.isLiked = false;

          interact.likeInfo = likeRes[i];
          interact.commentInfo = commentRes[i];

          likeRes[i].data.Result.map(function (item) {
            if (item.Id == JSON.parse(window.localStorage.user).Id) {
              interact.isLiked = true;
            }
          });
        });

        context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getInteractionListByUserId, itList);
        resolve();
      });
    });
  },
  getInteractionDetail: function getInteractionDetail(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.getInteractionDetail(data.interactionId, function (res) {
        if (res) {
          context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* live */].getInteractionDetail, res.data);
          resolve(res.data);
        } else {
          console.log('网络异常');
          reject();
        }
      });
    });
  },
  interactionPublish: function interactionPublish(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.publishInteraction(data.title, data.picture, data.activityId, function (res) {
        if (res) {
          resolve(res);
        } else {
          console.log('网络异常');
          reject();
        }
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(6);





var state = {
  wechatInfo: {}
};

var getters = {};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* user */].getCurrentUser, function (state, res) {
  state.wechatInfo = res;
});

var actions = {
  getCurrentUser: function getCurrentUser(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].user.signInWithWeChat(data.refresh_token, function (res) {
        console.log('====res', res);
        if (res.status == 200) {
          __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].user.getCurrentUser(function (data) {
            console.log('#####', data);
            if (data.status == 200) {
              context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* user */].getCurrentUser, data.data);
              resolve();
            } else {
              console.log('网络异常');
              reject(data);
            }
          });
        }
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__(238);
  __webpack_require__(391);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



window.videojs = __webpack_require__(71);
videojs = videojs.default || videojs;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-player',
  props: {
    options: {
      type: Object,
      required: true
    },
    start: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    playsinline: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    customEventName: {
      type: String,
      default: function _default() {
        return 'statechanged';
      }
    }
  },
  mounted: function mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },
  methods: {
    initialize: function initialize() {
      var self = this;
      this.player = null;

      var videoOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        autoplay: false,
        controls: true,
        preload: 'auto',
        fluid: false,
        muted: false,
        width: '100%',
        height: '360',
        language: 'en',
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true
          }
        },
        techOrder: ['html5'],
        plugins: {}
      }, this.options);

      var playsinline = this.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      var emitPlayerState = function emitPlayerState(event, value) {
        if (event) {
          self.$emit(event, self.player);
        }
        if (value) {
          var values = {};
          values[event] = value;
          self.$emit(self.customEventName, values);
        }
      };

      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }

      this.player = videojs(this.$el.children[0], videoOptions, function () {
        var _this = this;
        self.$emit('ready', self.player);

        var events = ['loadeddata', 'canplay', 'canplaythrough', 'play', 'pause', 'waiting', 'playing', 'ended', 'error'];
        for (var i = 0; i < events.length; i++) {
          ;(function (event) {
            _this.on(event, function () {
              emitPlayerState(event, true);
            });
          })(events[i]);
        }

        this.on('timeupdate', function () {
          emitPlayerState('timeupdate', this.currentTime());
        });
      });
    },
    dispose: function dispose() {
      if (this.player && videojs) {
        if (this.player.techName_ !== 'Flash') {
          this.player.pause && this.player.pause();
        }
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      }
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alert',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    }
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_router__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__props__ = __webpack_require__(331);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cell',
  components: {
    InlineDesc: __WEBPACK_IMPORTED_MODULE_0__inline_desc___default.a
  },
  props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__props__["a" /* default */])(),
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
  },

  computed: {
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    }
  },
  methods: {
    getLabelStyles: function getLabelStyles() {
      return {
        width: this.$parent.labelWidth || this.$parent.$parent.labelWidth,
        textAlign: this.$parent.labelAlign || this.$parent.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight
      };
    },
    onClick: function onClick() {
      !this.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_router__["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: false
    };
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirm',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onConfirm: function _onConfirm() {
      this.showValue = false;
      this.$emit('on-confirm');
    },
    _onCancel: function _onCancel() {
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'group',
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number]
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inline-desc'
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  created: function created() {
    this.show = this.value;
  },
  data: function data() {
    return {
      show: false
    };
  },

  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popup__ = __webpack_require__(332);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new __WEBPACK_IMPORTED_MODULE_1__popup__["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },

  methods: {
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;

      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    }
  },
  data: function data() {
    return {
      initialShow: true,
      hasFirstShow: false,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this3 = this;

      this.$emit('input', val);
      if (val) {
        this.popup && this.popup.show();
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');
        if (!this.hasFirstShow) {
          this.$emit('on-first-show');
          this.hasFirstShow = true;
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this3.fixSafariOverflowScrolling('touch');
          }
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qr_js_lib_QRCode__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qr_js_lib_QRCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qr_js_lib_QRCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qr_js_lib_ErrorCorrectLevel__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qr_js_lib_ErrorCorrectLevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qr_js_lib_ErrorCorrectLevel__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'qrcode',
  props: {
    value: String,
    size: {
      type: Number,
      default: 80
    },
    level: {
      type: String,
      default: 'L'
    },
    bgColor: {
      type: String,
      default: '#FFFFFF'
    },
    fgColor: {
      type: String,
      default: '#000000'
    },
    type: {
      type: String,
      default: 'img'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },
  data: function data() {
    return {
      imgData: ''
    };
  },

  watch: {
    value: function value() {
      this.render();
    },
    size: function size() {
      this.render();
    },
    level: function level() {
      this.render();
    },
    bgColor: function bgColor() {
      this.render();
    },
    fgColor: function fgColor() {
      this.render();
    }
  },
  methods: {
    render: function render() {
      var _this2 = this;

      var qrcode = new __WEBPACK_IMPORTED_MODULE_0_qr_js_lib_QRCode___default.a(-1, __WEBPACK_IMPORTED_MODULE_1_qr_js_lib_ErrorCorrectLevel___default.a[this.level]);
      qrcode.addData(this.value);
      qrcode.make();

      var canvas = this.$refs.canvas;

      var ctx = canvas.getContext('2d');
      var cells = qrcode.modules;
      var tileW = this.size / cells.length;
      var tileH = this.size / cells.length;
      var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
      canvas.height = canvas.width = this.size * scale;
      ctx.scale(scale, scale);

      cells.forEach(function (row, rdx) {
        row.forEach(function (cell, cdx) {
          ctx.fillStyle = cell ? _this2.fgColor : _this2.bgColor;
          var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
          var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
          ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
        });
      });
      if (this.type === 'img') {
        this.imgData = canvas.toDataURL('image/png');
      }
    }
  }
});

function getBackingStorePixelRatio(ctx) {
  return ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
}

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__ = __webpack_require__(84);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tab-item',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__(335);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_router__ = __webpack_require__(51);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: String
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_router__["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    classes: function classes() {
      return [{
        'weui-btn_disabled': this.disabled,
        'weui-btn_mini': this.mini
      }, 'weui-btn_' + this.type, this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.currentValue = val;
      },
      immediate: true
    },
    currentValue: function currentValue(val) {
      this.$emit(val ? 'on-show' : 'on-hide');
      this.$emit('input', val);
    }
  },
  data: function data() {
    return {
      currentValue: false
    };
  },

  methods: {
    onTouchMove: function onTouchMove(event) {
      !this.scroll && event.preventDefault();
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_base__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inline_desc__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autosize__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_autosize__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-textarea',
  minxins: [__WEBPACK_IMPORTED_MODULE_0__libs_base__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }

    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
  },

  components: {
    InlineDesc: __WEBPACK_IMPORTED_MODULE_1__inline_desc___default.a
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,

    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      if (this.max && newVal && newVal.length > this.max) {
        this.currentValue = newVal.slice(0, this.max);
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      return {
        width: this.$parent.labelWidth || this.labelWidth + 'em',
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    }
  },
  methods: {
    bindAutosize: function bindAutosize() {
      __WEBPACK_IMPORTED_MODULE_2_autosize___default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      __WEBPACK_IMPORTED_MODULE_2_autosize___default.a.destroy(this.$refs.textarea);
    },
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_store_mutation_types__ = __webpack_require__(17);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      transitionName: ''
    };
  },

  watch: {
    $route: function $route(to, from) {
      if (from.name == 'liveDetail' && to.name == 'liveInteraction') {
        this.transitionName = 'slide-left';
      }
      if (to.name == 'liveDetail' && from.name == 'liveInteraction') {
        this.transitionName = 'slide-right';
      }
    }
  },
  mounted: function mounted() {
    var view = {
      viewHeight: document.documentElement.clientHeight,
      viewWidth: document.documentElement.clientWidth
    };
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__src_store_mutation_types__["a" /* base */].setView, view);
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    scroll: function scroll() {
      if (this.$refs.adBar !== undefined) {
        if (window.scrollY > 250) {
          this.$refs.adBar.style.opacity = '1';
        } else {
          this.$refs.adBar.style.opacity = '0';
        }
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.scroll, false);
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_tools_date_format_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_tools_date_format_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_tools_date_format_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'count-down',
  data: function data() {
    return {
      countDown: '',
      show: true
    };
  },

  computed: {
    live: function live() {
      return this.$store.state.live.detail;
    }
  },
  methods: {
    time: function time() {
      var date1 = this.live.BeginAt;
      var date2 = __WEBPACK_IMPORTED_MODULE_0_vux_src_tools_date_format_js___default()(new Date(), 'YYYY-MM-DDTHH:mm:ss');
      var date3 = new Date(date1).getTime() - new Date(date2).getTime();

      if (date3 <= 0) {
        window.clearInterval(this.time);
        this.show = false;
        return false;
      }

      var days = Math.floor(date3 / (24 * 3600 * 1000));

      var leave1 = date3 % (24 * 3600 * 1000);
      var hours = Math.floor(leave1 / (3600 * 1000));

      var leave2 = leave1 % (3600 * 1000);
      var minutes = Math.floor(leave2 / (60 * 1000));

      var leave3 = leave2 % (60 * 1000);
      var seconds = Math.round(leave3 / 1000);
      this.countDown = days + '\u5929' + hours + '\u5C0F\u65F6' + minutes + '\u5206\u949F' + seconds + '\u79D2';
    }
  },
  mounted: function mounted() {
    setInterval(this.time, 1000);
  },

  components: {}
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Upload_Upload__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Upload_Upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Upload_Upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'face_page',
  data: function data() {
    return {
      showUpload: false
    };
  },

  computed: {
    token: function token() {
      return this.$store.state.base.qiniuToken;
    }
  },
  mounted: function mounted() {},

  methods: {
    uploaded: function uploaded(url) {
      var _this2 = this;

      var _this = this;
      var liveId = this.$route.params.liveId;
      _this.$vux.loading.show({
        text: '面孔智能识别中...'
      });

      this.$store.dispatch({
        type: 'getFaceList',
        liveId: liveId,
        url: url
      }).then(function () {
        _this.$vux.loading.hide();

        _this2.$router.push({
          name: 'FaceRecogPage',
          params: { liveId: liveId }
        });
      }).catch(function (err) {
        _this.$vux.loading.hide();
        _this.$vux.toast.show({
          type: 'warn',
          text: err.data.Message
        });
        setTimeout(function () {
          _this.$vux.toast.hide();
        }, 3000);
      });
    },
    showUpPanel: function showUpPanel() {
      this.showUpload = true;
      this.$refs.upload.init();
    },
    close: function close() {
      this.showUpload = false;
    }
  },
  components: {
    Upload: __WEBPACK_IMPORTED_MODULE_0__components_Upload_Upload___default.a
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['showInteract'],
  data: function data() {
    return {};
  },

  computed: {},
  methods: {
    next: function next(id) {
      if (id === 1) {
        document.getElementById('g1').style.display = 'none';
        document.getElementById('g2').style.opacity = 1;
      }
      if (id === 2) {
        document.getElementById('g1').style.display = 0;
        document.getElementById('g2').style.opacity = 0;
        document.getElementById('guide').style.display = "none";

        window.localStorage.setItem('visited', 'true');
      }
      if (id === 3) {
        document.getElementById('g3').style.opacity = 0;
        document.getElementById('guide').style.display = "none";

        window.localStorage.setItem('visited', 'true');
      }
    }
  },
  components: {}
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title']
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base64_url__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base64_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_base64_url__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['photos', 'isLoad'],
  data: function data() {
    return {
      arr: [],
      scrollDisabled: false,
      checkMode: false,
      checkList: []
    };
  },

  computed: {
    picCount: function picCount() {
      return this.$store.state.live.detail.PublishPicturesCount;
    },
    pageIndex: function pageIndex() {
      return this.$store.state.live.pageIndex;
    },
    list: function list() {
      return this.initPhotoList(this.photos);
    },
    previewerList: function previewerList() {
      return this.initPreviewPhotoList(this.photos);
    },
    pic_width: function pic_width() {
      return (this.$store.state.base.viewWidth - 8) / 3 + 'px';
    },
    pic_height: function pic_height() {
      return (this.$store.state.base.viewWidth - 8) / 4 + 'px';
    },
    large_pic_width: function large_pic_width() {
      return this.$store.state.base.viewWidth - 4 + 'px';
    },
    large_pic_height: function large_pic_height() {
      return (this.$store.state.base.viewWidth - 4) / 16 * 9 + 'px';
    }
  },
  methods: {
    initPhotoList: function initPhotoList(list) {
      var _this = this;

      var arr = [];
      if (list) {
        list.map(function (item, index) {
          if (item.IsLarge) {
            arr.push({
              pic: item,
              url: _this.initQiniu(item.Url, true)
            });
          } else {
            arr.push({
              pic: item,
              url: _this.initQiniu(item.Url, false)
            });
          }
        });
        this.$nextTick(function () {
          _this.scrollDisabled = false;
          _this.$vux.loading.hide();
        });
      }
      return arr;
    },
    toggleMode: function toggleMode() {
      this.checkList = [];
      this.checkMode = !this.checkMode;
    },
    show: function show(index) {
      this.$emit('showPre', index);
    },
    isChecked: function isChecked(id) {
      return this.checkList.indexOf(id) == -1 ? false : true;
    },
    checkThis: function checkThis(id) {
      var _this2 = this;

      var flag = false;

      this.checkList.map(function (item, i) {
        if (item == id) {
          _this2.checkList.splice(i, 1);
          flag = true;
        }
      });

      if (!flag) {
        if (this.checkList.length > 4) {
          alert('最多只能选择5张拼图~');
          return;
        }
        this.checkList.push(id);
      }
    },
    checkOK: function checkOK() {
      if (this.checkList.length <= 0) {
        alert('至少选择一张图哦！');
        return;
      }

      this.$emit('startShot', this.checkList);
    },
    checkCancel: function checkCancel() {
      this.checkMode = false;
      this.$emit('cancelShot');
    },
    initQiniu: function initQiniu(link, isLarge) {
      if (isLarge) {
        return link + '?imageView2%2F1%2Fw%2F600%2Fh%2F450%2F';
      } else {
        return link + '?imageView2/1/w/200/h/150';
      }
    },
    infiniteLoad: function infiniteLoad() {
      console.log('infiniteLoad', this.scrollDisabled);

      if (!this.scrollDisabled && document.documentElement.offsetHeight != 0 && document.documentElement.clientHeight + window.scrollY >= document.documentElement.offsetHeight) {
        this.scrollDisabled = true;

        if (this.photos.length < this.picCount) {
          this.loadMore();
        }
      }
    },
    loadMore: function loadMore() {
      this.$emit('loadMore');
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.infiniteLoad, false);
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_XPreview_XPreview__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_XPreview_XPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_XPreview_XPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_popup_index_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_popup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_group_index_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_group_index_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_4_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  data: function data() {
    return {
      likeDisabled: false,
      showConfirm: false,
      confirm_title: '',
      onConfirm: '',
      isAct: false,
      fetchDisabled: false,
      pageIndex: 1,
      pageSize: 5,
      liveId: 0,
      content: '',
      currentCommentId: '',
      currentCommentIndex: 0,
      showComment: false,
      commentPageIndex: 1,
      interactionList: [],
      scrollDisabled: false,
      loadMessage: '努力加载中 ...',
      previewerList: [],
      options: {
        bgOpacity: 0.9,
        loop: false,
        clickToCloseNonZoomable: false,
        tapToClose: false,
        isClickableElement: function isClickableElement(el) {
          if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
            return true;
          } else {
            return false;
          }
        },
        errorMsg: '<div class="pswp__error-msg">哎呀，图片加载不出来了...</div>'
      }
    };
  },

  components: {
    Previewer: __WEBPACK_IMPORTED_MODULE_3__components_XPreview_XPreview___default.a,
    Popup: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_popup_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue___default.a,
    XTextarea: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_group_index_vue___default.a,
    Confirm: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue___default.a,
    WechatShare: __WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare___default.a
  },
  computed: {
    list: function list() {
      return this.$store.state.live.interactionList.Result;
    },
    live: function live() {
      return this.$store.state.live.detail;
    },
    interactionCount: function interactionCount() {
      return this.$store.state.live.interactionList.Total;
    }
  },
  methods: {
    onCancel: function onCancel() {
      console.log('on cancel');
    },
    onHide: function onHide() {
      console.log('on hide');
    },
    onShow: function onShow() {
      console.log('on show');
    },
    like: function like(id, index) {
      var _this = this;

      var u = JSON.parse(window.localStorage.user);
      if (!this.likeDisabled) {
        this.likeDisabled = true;

        if (this.interactionList[index].isLiked) {
          __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].live.unLike(id).then(function () {
            _this.$vux.toast.show({
              text: '已取消赞'
            });

            _this.interactionList[index].isLiked = false;

            _this.interactionList[index].LikesCount--;

            var result = _this.interactionList[index].likeInfo.data.Result;
            var rmIndex = 0;
            result.map(function (item, i) {
              if (item.Id == JSON.parse(window.localStorage.user).Id) {
                rmIndex = i;
              }
            });
            _this.interactionList[index].likeInfo.data.Result.splice(rmIndex, 1);
            setTimeout(function () {
              _this.likeDisabled = false;
            }, 2000);
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].live.like(id).then(function () {
            _this.$vux.toast.show({
              text: '已赞'
            });

            _this.interactionList[index].isLiked = true;

            _this.interactionList[index].LikesCount++;

            _this.interactionList[index].likeInfo.data.Result.unshift({
              Nickname: u.Nickname,
              Avatar: u.Avatar
            });
            setTimeout(function () {
              _this.likeDisabled = false;
            }, 2000);
          });
        }
      }
    },
    comment: function comment(id, index) {
      this.content = '';
      this.currentCommentId = id;
      this.currentCommentIndex = index;
      this.showComment = true;
    },
    touch: function touch() {
      this.isAct = true;
    },
    touchend: function touchend() {
      this.isAct = false;
    },
    loadComment: function loadComment(index, interId, data, pageSize) {
      var _this2 = this;

      if (this.interactionList[index].commentInfo.data.PageIndex < data.PageCount) {
        this.interactionList[index].commentInfo.data.PageIndex++;

        __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].live.getInteractionCommentList(interId, this.interactionList[index].commentInfo.data.PageIndex, pageSize).then(function (res) {
          if (res.data.Result.length > 0) {
            res.data.Result.map(function (item) {
              _this2.interactionList[index].commentInfo.data.Result.push(item);
            });
          }
        });
      }
    },
    fetchMore: function fetchMore() {
      if (!this.fetchDisabled) {
        this.fetchDisabled = true;
        this.$vux.loading.show({
          text: '正在加载...'
        });
        this.scrollDisabled = true;
        this.pageIndex = 1;
        this.interactionList = [];
        this.loadMessage = '努力加载中 ...';
        this.fetchInteraction();
      }
    },
    show: function show(url, index) {
      var new_url = encodeURIComponent(url);
      var width = document.getElementById(index).width;
      var height = document.getElementById(index).height;

      this.previewerList = [];
      var item = {
        'w': width * 10,
        'h': height * 10,
        'src': url
      };
      this.previewerList.push(item);
      this.$refs.previewer.show(item);
    },
    loadMore: function loadMore() {
      if (!this.scrollDisabled && document.documentElement.offsetHeight != 0 && document.documentElement.clientHeight + window.scrollY >= document.documentElement.offsetHeight) {
        this.scrollDisabled = true;

        if (this.interactionList.length < this.interactionCount) {
          this.pageIndex++;
          this.fetchInteraction();
        } else {
          this.loadMessage = '已经到底了';
        }
      }
    },
    publish: function publish() {
      var _this3 = this;

      var u = JSON.parse(window.localStorage.user);
      if (this.validate()) {
        __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].live.addComment(this.currentCommentId, this.content).then(function (cid) {
          _this3.interactionList[_this3.currentCommentIndex].commentInfo.data.Result.push({
            Id: cid,
            Content: _this3.content,
            UserId: u.Id,
            User: {
              Nickname: u.Nickname,
              Avatar: u.Avatar
            }
          });

          _this3.interactionList[_this3.currentCommentIndex].commentInfo.data.Total++;

          _this3.showComment = false;
        });
      }
    },
    validate: function validate() {
      if (this.content.length == 0) {
        this.$vux.toast.show({
          type: 'text',
          width: '150px',
          text: '您还没有填写内容哦~'
        });
        return false;
      }
      return true;
    },
    cancel: function cancel() {
      var _this4 = this;

      this.confirm_title = '确定放弃编辑的内容？';
      this.showConfirm = true;
      this.onConfirm = function () {
        return _this4.showComment = false;
      };
    },
    fetchInteraction: function fetchInteraction() {
      var _this5 = this;

      if (!this.live.Title) {
        this.$store.dispatch({
          type: 'getLiveDetail',
          liveId: this.liveId
        });
      }

      this.$store.dispatch({
        type: 'getInteractionList',
        liveId: this.liveId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(function () {
        _this5.list.map(function (item) {
          _this5.interactionList.push(item);
        });

        _this5.$nextTick(function () {
          _this5.scrollDisabled = false;
          _this5.$vux.loading.hide();
          _this5.fetchDisabled = false;
        });
      });
    },
    dateFormat: function dateFormat(time) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('MM月DD日 HH:mm');
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.name == 'liveInteraction' && from.name == 'liveInteractionPublish') {
        this.interactionList = [];
        this.pageIndex = 1;
        this.fetchInteraction();
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.loadMore, false);

    this.scrollDisabled = true;
    this.liveId = this.$route.params.liveId;

    this.fetchInteraction();
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['delay', 'liveData'],
  computed: {
    logo: function logo() {
      return this.$store.state.live.detail.LoadingImage;
    },
    screenImage: function screenImage() {
      return this.$store.state.live.detail.FlashScreenImage;
    },
    url: function url() {
      if (this.$store.state.live.detail.Id === '20180525hz2') {
        if (this.isIphoneX()) {
          return 'https://assets.aiyaopai.com/WechatIMG1730.jpeg';
        } else {
          return this.$store.state.live.detail.FlashScreenImage;
        }
      } else {
        return this.$store.state.live.detail.FlashScreenImage;
      }
    }
  },
  data: function data() {
    return {
      isShow: true,
      times: this.delay / 1000,
      flag: '',
      width: 0,
      height: 0
    };
  },
  mounted: function mounted() {
    this.width = document.documentElement.clientWidth + 'px';
    this.height = document.documentElement.clientHeight + 'px';
  },


  watch: {
    liveData: function liveData() {
      var _this = this;

      if (this.liveData.Id) {
        this.isShow = true;
        if (this.screenImage) {
          this.flag = 'customer';
        } else {
          this.flag = 'def';
        }
        this.width = document.documentElement.clientWidth + 'px';
        this.height = document.documentElement.clientHeight + 'px';
        this.calu();
        setTimeout(function () {
          _this.hidden();
        }, this.delay);
      }
    }
  },
  methods: {
    calu: function calu() {
      var _this2 = this;

      setInterval(function () {
        --_this2.times;
      }, 1000);
    },
    show: function show() {
      this.isShow = true;
    },
    isIphoneX: function isIphoneX() {
      return (/iphone/gi.test(navigator.userAgent) && screen.height == 812 && screen.width == 375
      );
    },
    hidden: function hidden() {
      this.isShow = false;
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_tools_querystring_index_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_tools_querystring_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_tools_querystring_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_tools_date_format_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_tools_date_format_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_tools_date_format_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      liveId: ''
    };
  },

  methods: {
    login: function login(to, from) {
      var _this = this;

      var url = __WEBPACK_IMPORTED_MODULE_1_vux_src_tools_querystring_index_js___default.a.parse(window.location.hash);
      if (url.access_token) {
        this.$store.dispatch({
          type: 'getCurrentUser',
          refresh_token: url.refresh_token
        }).then(function () {
          var user = _this.$store.state.user.wechatInfo;

          window.localStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user);

          var now = __WEBPACK_IMPORTED_MODULE_2_vux_src_tools_date_format_js___default()(new Date(), 'YYYY-MM-DD HH:mm:ss');
          window.localStorage.validDate = new Date();
          if (window.localStorage.beforeUrl) {
            window.location.href = window.localStorage.getItem('beforeUrl');
            window.localStorage.removeItem('beforeUrl');
          } else {
            if (window.localStorage.to) {
              var routers = JSON.parse(window.localStorage.to);
              window.location.href = window.location.origin + routers.path;
              window.localStorage.removeItem('to');
            }
          }
        }).catch(function (err) {
          var redUrl = encodeURI(window.location.origin + '/login');
          var url = 'https://wechatauth.aiyaopai.com/auth/clientside?appid=wx76b9a692b8709d44&redirect_uri=' + redUrl + '&response_type=code&scope=snsapi_userinfo&state=21';
          window.location.href = url;
        });
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.login();
    });
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pass_view',
  props: {
    pass: String,
    id: String
  },
  data: function data() {
    return {
      isShow: true
    };
  },

  computed: {},
  methods: {
    enter: function enter() {
      var _this = this;

      var ps = document.getElementById('pass').value;
      if (ps === this.pass) {
        this.$vux.loading.show({
          text: '正在进入现场...'
        });
        setTimeout(function () {
          _this.$vux.loading.hide();

          window.localStorage[_this.id] = new Date();
          _this.isShow = false;
        }, 1500);
      } else {
        this.$vux.alert.show({
          title: '提示',
          content: '密码输入有误,请重试'
        });
        this.isShow = true;
      }
    }
  },
  mounted: function mounted() {},

  components: {}
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_toast_index_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_toast_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_toast_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    },
    totalNum: function totalNum() {
      return this.$store.state.live.detail.PublishPicturesCount;
    }
  },
  data: function data() {
    return {
      pic_size: 0,
      pic_title: '',
      pic_time: '',
      total: 0,
      isLoading: false,
      isOrigin: false,
      current: 0,
      showPositionValue: false,
      position: 'default'
    };
  },

  components: {
    Toast: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_toast_index_vue___default.a
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      this._init(index);
    },
    _init: function _init(index) {
      var _this2 = this;

      var self = this;
      var options = __WEBPACK_IMPORTED_MODULE_2_object_assign___default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new __WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe___default.a(this.$el, __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default___default.a, this.imgs, options);
      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this2.$emit('on-close');
      });

      var _this = this;
      var pw = this.photoswipe;
      this.photoswipe.listen('afterChange', function () {
        _this.pic_time = this.currItem.info.OriginalAt.replace(/T/, ' ');
        _this.pic_title = this.currItem.info.Title;
        _this.pic_size = parseInt(this.currItem.info.Size / 1024);
        _this.isOrigin = this.currItem.isOrigin;
        _this.total = _this.totalNum;
        _this.current = this.getCurrentIndex() + 1;

        if (_this.current >= this.items.length - 5 && _this.current < _this.total) {
          _this.loadMore();

          setTimeout(function () {
            _this.imgs.map(function (item, index) {
              if (index > pw.items.length) {
                pw.items.push(item);
              }
            });
            pw.updateSize(true);
          }, 1000);
        }
      });
      this.photoswipe.listen('gettingData', function (index, item) {
        _this.pic_time = this.currItem.info.OriginalAt.replace(/T/, ' ');
        _this.pic_title = this.currItem.info.Title;
        _this.pic_size = parseInt(this.currItem.info.Size / 1024);
        _this.total = _this.totalNum;
        _this.isOrigin = this.currItem.isOrigin;
        _this.current = this.getCurrentIndex() + 1;
      });
    },
    showPosition: function showPosition(position) {
      this.position = position;
      this.showPositionValue = true;
    },
    show: function show(index) {
      this.init(index);
    },
    showOrigin: function showOrigin(index) {
      var _this3 = this;

      this.isLoading = true;
      this.imgs[index - 1].src = this.imgs[index - 1].origin_url;
      this.imgs[index - 1].isOrigin = true;

      this.photoswipe.invalidateCurrItems();
      this.photoswipe.updateSize(true);
      var _this = this;
      var timer = setInterval(function () {
        if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this3.photoswipe.currItem.container.childNodes[1])[0]) {
          if (__WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this3.photoswipe.currItem.container.childNodes[1])[0].complete) {
            clearInterval(timer);
            _this3.isLoading = false;
          }
        }
      }, 100);
    },
    close: function close() {
      this.photoswipe.close();
    },
    loadMore: function loadMore() {
      this.$emit('loadMore');
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_0_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  data: function data() {
    return {
      isShow: false,
      itemInfo: {}
    };
  },

  props: ['list'],
  methods: {
    showLogo: function showLogo(obj) {
      this.itemInfo = obj;
      this.isShow = true;
    },
    tinyPic: function tinyPic(url) {
      return url + '?imageView2/1/w/300/h/300';
    }
  },
  components: {
    Popup: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_popup_index_vue___default.a
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vux_src_mixins_multi_items_js__ = __webpack_require__(84);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tab',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__node_modules_vux_src_mixins_multi_items_js__["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String]
  },
  computed: {
    barLeft: function barLeft() {
      return this.currentIndex * 120 + 'px';
    },
    barRight: function barRight() {
      console.log(this.number);
      return (this.number - this.currentIndex - 1) * (100 / this.number) + '%';
    },
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent';
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["text", "icon"],
  methods: {
    scroll: function scroll() {
      if (this.$refs.scrollTip) {
        if (window.scrollY > 250) {
          this.$refs.scrollTip.style.opacity = 0;
        } else {
          this.$refs.scrollTip.style.opacity = 1;
        }
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.scroll, false);
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['text', 'subTitle'],
  mounted: function mounted() {}
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'upload_qiniu',
  props: {
    pId: String,
    bId: String,
    cb: Function
  },
  data: function data() {
    return {
      token: ''
    };
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    init: function init() {
      this.getCurrentUser();

      this.getQiniuToken();
    },
    getCurrentUser: function getCurrentUser() {
      __WEBPACK_IMPORTED_MODULE_0__api_api__["a" /* default */].user.getCurrentUser(function (user) {
        if (user.status !== 200) {
          window.localStorage.beforeUrl = window.location.href;

          var redUrl = encodeURI(window.location.origin + '/login');
          var url = 'https://wechatauth.aiyaopai.com/auth/clientside?appid=wx76b9a692b8709d44&redirect_uri=' + redUrl + '&response_type=code&scope=snsapi_userinfo&state=21';
          window.location.href = url;
        }
      });
    },
    getQiniuToken: function getQiniuToken() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__api_api__["a" /* default */].base.getQiniuToken().then(function (res) {
        if (res.status == 200) {
          _this2.token = res.data.Token;
          _this2.initQiniu();
        }
      }).catch(function (err) {
        console.log('获取token错误', err);
      });
    },
    initQiniu: function initQiniu() {
      var _this = this;
      var domain = window.location.host == 'yun.aiyaopai.com' || window.location.host === 'yun.aiyaopai.com' ? 'https://storage-live-user.aiyaopai.com' : 'https://storage-live-user.dev.aiyaopai.com';
      var uploader = Qiniu.uploader({
        runtimes: 'html5,flash,html4',
        browse_button: this.bId,
        uptoken: this.token,
        get_new_uptoken: false,
        domain: domain,
        container: this.pId,
        max_file_size: '100mb',
        flash_swf_url: 'path/of/plupload/Moxie.swf',
        max_retries: 3,
        dragdrop: true,
        drop_element: this.pId,
        chunk_size: '4mb',
        auto_start: true,
        multi_selection: false,
        init: {
          FilesAdded: function FilesAdded(up, files) {
            plupload.each(files, function (file) {});
          },
          BeforeUpload: function BeforeUpload(up, file) {},
          UploadProgress: function UploadProgress(up, file) {
            _this.$vux.loading.show({
              text: '正在上传中...'
            });
          },
          FileUploaded: function FileUploaded(up, file, info) {
            _this.$vux.loading.hide();
            var fmt_info = eval('(' + info + ')');
            if (fmt_info.success) {
              var url = fmt_info.url;

              _this.cb(url + '?imageMogr2/size-limit/2000k!/thumbnail/4000x4000>');
            }
          },
          Error: function Error(up, err, errTip) {
            alert('上传图片格式错误');
          },
          UploadComplete: function UploadComplete() {},
          Key: function Key(up, file) {
            var key = '';

            return key;
          }
        }
      });
    }
  },
  components: {}
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'subTitle', 'shareImg'],
  watch: {
    $route: 'fetch'
  },
  methods: {
    fetch: function fetch() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
        var LINK = window.location.href;

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
          url: 'https://wechatauth.aiyaopai.com/auth/jsapisignature',
          type: 'Get',
          async: false,
          dataType: 'jsonp',
          jsonp: 'callback',
          jsonpCallback: 'gdd',
          success: function success(data) {
            wx.config({
              debug: false,
              appId: data.AppId,
              timestamp: data.Timestamp,
              nonceStr: data.NonceString,
              signature: data.Signature.toLowerCase(),
              jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo'] });

            wx.ready(function () {
              wx.onMenuShareTimeline({
                title: _this.title,
                link: LINK,
                imgUrl: _this.shareImg,
                success: function success() {},
                cancel: function cancel() {}
              });

              wx.onMenuShareAppMessage({
                title: _this.title,
                desc: _this.subTitle,
                link: LINK,
                imgUrl: _this.shareImg,
                type: '',
                dataUrl: '',
                success: function success() {},
                cancel: function cancel() {}
              });
            });
          }
        });
      });
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_popup_index_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_popup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_cell_index_vue__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_cell_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_cell_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(17);








/* harmony default export */ __webpack_exports__["default"] = ({
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_1_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  props: ['upload', 'menu', 'title'],
  data: function data() {
    return {
      show: false,
      showLoading: false,
      refresh_token: '',
      text: '正在上传中...'
    };
  },

  computed: {
    user: function user() {
      return JSON.parse(window.localStorage.user);
    },
    token: function token() {
      return this.$store.state.base.qiniuToken;
    },
    live: function live() {
      return this.$store.state.live.detail;
    }
  },
  methods: {
    showMenu: function showMenu() {
      this.show = true;
    },
    back: function back() {
      this.$router.go(-1);
    },
    getQiniuToken: function getQiniuToken() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$store.dispatch('getQiniuToken').then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    initQiniu: function initQiniu() {
      var _this = this;
      var domain = window.location.host == 'yun.aiyaopai.com' || window.location.host == 'yun.aiyaopai.com' ? 'https://storage-live-user.aiyaopai.com' : 'https://storage-live-user.dev.aiyaopai.com';
      var uploader = Qiniu.uploader({
        runtimes: 'html5,flash,html4',
        browse_button: 'pickfiles',
        uptoken: this.token,
        get_new_uptoken: false,
        domain: domain,
        container: 'container',
        max_file_size: '100mb',
        flash_swf_url: 'path/of/plupload/Moxie.swf',
        max_retries: 3,
        dragdrop: true,
        drop_element: 'container',
        chunk_size: '4mb',
        auto_start: true,
        multi_selection: false,
        init: {
          FilesAdded: function FilesAdded(up, files) {
            plupload.each(files, function (file) {});
          },
          BeforeUpload: function BeforeUpload(up, file) {},
          UploadProgress: function UploadProgress(up, file) {
            _this.$vux.loading.show({
              text: '正在上传中...'
            });
          },
          FileUploaded: function FileUploaded(up, file, info) {
            _this.$vux.loading.hide();
            var fmt_info = eval('(' + info + ')');
            if (fmt_info.success) {
              var url = fmt_info.url;

              _this.$router.push({
                name: 'liveInteractionPublish',
                params: {
                  pic: url
                }
              });
            }
          },
          Error: function Error(up, err, errTip) {
            alert('上传图片格式错误');
          },
          UploadComplete: function UploadComplete() {},
          Key: function Key(up, file) {
            var key = '';

            return key;
          }
        }
      });
    }
  },

  components: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_1_vux_src_directives_transfer_dom_index_js__["a" /* default */],
    Popup: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_popup_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default.a,
    Cell: __WEBPACK_IMPORTED_MODULE_4_vux_src_components_cell_index_vue___default.a
  },

  mounted: function mounted() {
    var _this3 = this;

    this.getQiniuToken().then(function (res) {
      _this3.initQiniu();
    }).catch(function (err) {
      if (err.response.status == 401) {
        var redUrl = encodeURI(window.location.origin + '/login');
        var url = 'https://wechatauth.aiyaopai.com/auth/clientside?appid=wx76b9a692b8709d44&redirect_uri=' + redUrl + '&response_type=code&scope=snsapi_userinfo&state=21';
        window.location.href = url;
      }
    });
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      id: '',
      current: 0,
      showPositionValue: false,
      position: 'default',
      img_list: []
    };
  },

  computed: {
    interact: function interact() {
      return this.data[this.index];
    }
  },
  methods: {
    remove: function remove() {
      var _this = this;

      if (confirm('确定删除当前作品么？')) {
        __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.removeInteraction(this.interact.Id).then(function () {
          _this.$emit('refresh');
          _this.photoswipe.close();
        });
      }
    },
    init: function init() {
      var self = this;
      this._init(0);
    },
    _init: function _init(index) {
      var _this2 = this;

      var self = this;
      var options = __WEBPACK_IMPORTED_MODULE_2_object_assign___default()({
        history: false,
        shareEl: false,
        tapToClose: false,
        index: index
      }, this.options);
      this.photoswipe = new __WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe___default.a(this.$el, __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default___default.a, this.img_list, options);
      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this2.$emit('on-close');
      });
    },
    showPosition: function showPosition(position) {
      this.position = position;
      this.showPositionValue = true;
    },
    direct: function direct() {
      var liveId = this.$route.params.liveId;
      this.$router.push({
        name: 'userInteractionDetail',
        params: { liveId: liveId, interactionId: this.id }
      });
    },
    show: function show(item, id) {
      this.id = id;
      this.img_list = [];
      this.img_list.push({
        w: item.w,
        h: item.h,
        src: item.src
      });
      this.init();
    },
    close: function close() {
      this.photoswipe.close();
    }
  },
  props: ['list', 'index', 'options', 'data']
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      current: 0,
      showPositionValue: false,
      position: 'default',
      img_list: []
    };
  },

  methods: {
    init: function init() {
      var self = this;
      this._init(0);
    },
    _init: function _init(index) {
      var _this = this;

      var self = this;
      var options = __WEBPACK_IMPORTED_MODULE_2_object_assign___default()({
        history: false,
        shareEl: false,
        tapToClose: false,
        index: index
      }, this.options);
      this.photoswipe = new __WEBPACK_IMPORTED_MODULE_0_photoswipe_dist_photoswipe___default.a(this.$el, __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe_ui_default___default.a, this.img_list, options);

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
    },
    showPosition: function showPosition(position) {
      this.position = position;
      this.showPositionValue = true;
    },
    show: function show(item) {
      this.img_list = [];
      this.img_list.push({
        w: item.w,
        h: item.h,
        src: item.src + '?imageMogr2/auto-orient'
      });
      this.init();
    },
    close: function close() {
      this.photoswipe.close();
    }
  },
  props: ['list', 'index', 'options']
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_qrcode_index_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_qrcode_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_qrcode_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_html2canvas__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'screen_shot',
  props: {
    fn_close: Function
  },
  data: function data() {
    return {
      show_panel: false,
      show_loading: true,
      token: ''
    };
  },

  methods: {
    init: function init() {
      var _this2 = this;

      this.show_panel = true;

      this.initAuth();

      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').scrollTop(0);

      setTimeout(function () {
        _this2.startShot().then(function (baseUrl) {
          return _this2.base2url(baseUrl);
        }).then(function (url) {
          document.querySelector('.showPic').setAttribute('src', url);
          var timer = setInterval(function () {
            if (document.querySelector('.showPic').complete) {
              clearInterval(timer);

              _this2.show_loading = false;
            }
          }, 100);
        });
      }, 500);
    },
    initAuth: function initAuth() {
      __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].user.getCurrentUser(function (user) {
        if (user.status !== 200) {
          window.localStorage.beforeUrl = window.location.href;

          var redUrl = encodeURI(window.location.origin + '/login');
          var url = 'https://wechatauth.aiyaopai.com/auth/clientside?appid=wx76b9a692b8709d44&redirect_uri=' + redUrl + '&response_type=code&scope=snsapi_userinfo&state=21';
          window.location.href = url;
        }
      });
    },
    base2url: function base2url(base64) {
      var _this = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var pic = base64.replace(/^.*?,/, '');
        __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].base.getQiniuToken().then(function (res) {
          var token = res.data.Token;

          function strToJson(str) {
            var json = eval('(' + str + ')');
            return json;
          }
          var url = 'https://upload.qiniu.com/putb64/-1/';
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
              var keyText = xhr.responseText;

              keyText = strToJson(keyText);
              resolve(keyText.url);
            }
          };
          xhr.open('POST', url, true);
          xhr.setRequestHeader('Content-Type', 'application/octet-stream');
          xhr.setRequestHeader('Authorization', 'UpToken ' + token);
          xhr.send(pic);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    startShot: function startShot() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3_html2canvas___default()(document.querySelector('#shot'), {
          useCORS: true,
          logging: false,
          async: false,
          height: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#shot').outerHeight() }).then(function (canvas) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#hidepic').html(canvas);
          var img = new Image();
          var myCanvas = document.getElementById('myCanvas');

          myCanvas.width = canvas.width;
          myCanvas.height = canvas.height;
          var ctx = myCanvas.getContext('2d');
          if (img.complete) {
            img.src = canvas.toDataURL('image/jpeg');
            img.onload = function () {
              ctx.drawImage(img, 0, 0);

              document.getElementById('shot').outerHTML = '';

              var url = myCanvas.toDataURL('image/jpeg');
              resolve(url);
            };
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    close: function close() {
      this.show_panel = false;
      this.show_loading = true;
      this.fn_close();
    }
  },

  components: {
    Qrcode: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_qrcode_index_vue___default.a
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_qrcode_index_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_qrcode_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_qrcode_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'screen_shot',
  props: {
    url: String,
    fn_close: Function
  },
  data: function data() {
    return {
      show_panel: false,
      show_loading: true,
      token: '',
      pic_url: ''
    };
  },

  methods: {
    init: function init(arr, liveId) {
      var _this = this;

      this.show_panel = true;
      this.pic_url = '';

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].live.combinePicture(arr, liveId).then(function (res) {
        if (res) {
          _this.pic_url = res.Result;
          _this.show_loading = false;
        }
      });
    },
    close: function close() {
      this.show_panel = false;
      this.show_loading = true;
      this.fn_close();
    }
  },

  components: {
    Qrcode: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_qrcode_index_vue___default.a
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {}
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  components: {}
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Upload_Upload__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Upload_Upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Upload_Upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_tools_base64_index_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_tools_base64_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_tools_base64_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Previewer_Previewer__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Previewer_Previewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Previewer_Previewer__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'face_page',
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_1_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  data: function data() {
    return {
      options: {
        bgOpacity: 0.9,
        loop: false,
        clickToCloseNonZoomable: false,
        tapToClose: false,
        errorMsg: '<div class="pswp__error-msg">哎呀，图片加载不出来了...</div>',
        isClickableElement: function isClickableElement(el) {
          if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
            return true;
          } else {
            return false;
          }
        }
      }
    };
  },

  computed: {
    faceList: function faceList() {
      if (this.$store.state.live.faceList) {
        this.initFaceList(this.$store.state.live.faceList);
      }
      return this.$store.state.live.faceList;
    },
    previewerList: function previewerList() {
      if (this.$store.state.live.faceList) {
        return this.initPreviewPhotoList(this.$store.state.live.faceList);
      }
      return this.$store.state.live.faceList;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      _this2.$refs.upload.init();
    }, 500);
  },

  methods: {
    initFaceList: function initFaceList(list) {
      var watermark = __WEBPACK_IMPORTED_MODULE_2_vux_src_tools_base64_index_js___default.a.encode(this.$store.state.live.detail.Watermark);

      var encodeUrl = void 0;
      encodeUrl = encodeURIComponent('imageslim|watermark/1/image/' + watermark + '/dissolve/90/gravity/SouthEast');
      var arr = [];
      list.map(function (item) {
        item.Url = '' + item.Url;
        arr.push(item);
      });
      return arr;
    },
    initPreviewQiniu: function initPreviewQiniu(live) {
      var watermark = __WEBPACK_IMPORTED_MODULE_2_vux_src_tools_base64_index_js___default.a.encode(this.$store.state.live.detail.Watermark);

      var encodeUrl = void 0;
      encodeUrl = encodeURIComponent('imageslim|watermark/1/image/' + watermark + '/dissolve/90/gravity/SouthEast');

      var url = live.Url + '?' + encodeUrl;
      return url;
    },
    initPreviewPhotoList: function initPreviewPhotoList(list) {
      var _this3 = this;

      var preview_arr = [];
      if (list) {
        list.map(function (item, index) {
          var url = '';
          var originUrl = _this3.initOriginPic(item);
          url = _this3.initPreviewQiniu(item);
          preview_arr.push({
            info: item,
            src: url,
            isOrigin: false,
            w: item.Width,
            h: item.Height,
            origin_url: originUrl
          });
        });
      }
      return preview_arr;
    },
    initOriginPic: function initOriginPic(live) {
      var new_url = '';
      if (live) {
        var img_watermark = __WEBPACK_IMPORTED_MODULE_2_vux_src_tools_base64_index_js___default.a.encode(this.$store.state.live.detail.Watermark || '');
        var encodeUrl = void 0;
        encodeUrl = encodeURIComponent('watermark/1/image/' + img_watermark + '/dissolve/90/gravity/SouthEast');
        new_url = live.Url + '?' + encodeUrl;
      }
      return new_url;
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    uploaded: function uploaded(url) {
      var _this4 = this;

      var _this = this;
      var liveId = this.$route.params.liveId;
      _this.$vux.loading.show({
        text: '面孔智能识别中...'
      });

      this.$store.dispatch({
        type: 'getFaceList',
        liveId: liveId,
        url: url
      }).then(function () {
        _this.$vux.loading.hide();

        _this4.$router.push({
          name: 'FaceRecogPage',
          params: { liveId: liveId }
        });
      }).catch(function (err) {
        _this.$vux.toast.show({
          type: 'warn',
          text: err.data.Message
        });
        setTimeout(function () {
          _this.$vux.toast.hide();
        }, 3000);
      });
    }
  },
  components: {
    Upload: __WEBPACK_IMPORTED_MODULE_0__components_Upload_Upload___default.a,
    Previewer: __WEBPACK_IMPORTED_MODULE_3__components_Previewer_Previewer___default.a
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_XShot_Shot__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_XShot_Shot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_XShot_Shot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_qrcode_index_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_qrcode_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_qrcode_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hotView',
  data: function data() {
    return {
      print: {},
      pageIndex: 1,
      pageSize: 50
    };
  },

  computed: {
    live: function live() {
      return this.$store.state.live.detail;
    },
    list: function list() {
      return this.$store.state.live.largePhotoList;
    },
    url: function url() {
      return 'https://yun.aiyaopai.com/live/' + this.$route.params.liveId;
    }
  },
  methods: {
    shot: function shot(item) {
      var _this = this;

      this.print = item;
      this.$refs.shot.init();
      setTimeout(function () {
        _this.$refs.qrcode.$el.querySelector('img').style.width = '56px';
        _this.$refs.qrcode.$el.querySelector('img').style.height = '56px';
      }, 200);
    }
  },
  components: {
    Shot: __WEBPACK_IMPORTED_MODULE_0__components_XShot_Shot___default.a,
    Qrcode: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_qrcode_index_vue___default.a,
    WechatShare: __WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare___default.a
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      _this2.$vux.loading.hide();
    }, 1000);

    this.$store.dispatch({
      type: 'getLiveDetail',
      liveId: this.$route.params.liveId,
      router: this.$router
    });
    var options = {
      isLarge: true,
      liveId: this.$route.params.liveId,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    };

    this.$store.dispatch({
      type: 'getLargePhotoList',
      option: options
    });
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  components: {}
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_XHeader_XHeader__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_XHeader_XHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_XHeader_XHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WechatShare_WechatShare__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_WechatShare_WechatShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_WechatShare_WechatShare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Interaction_InteractionList__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Interaction_InteractionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Interaction_InteractionList__);






/* harmony default export */ __webpack_exports__["default"] = ({

  props: [],
  data: function data() {
    return {
      refresh_token: '',
      show: false,
      text: '正在上传中...'
    };
  },

  computed: {
    token: function token() {
      return this.$store.state.base.qiniuToken;
    },
    user: function user() {
      if (window.localStorage.user) {
        return JSON.parse(window.localStorage.user);
      } else {
        return this.$store.state.user.wechatInfo;
      }
    },
    live: function live() {
      return this.$store.state.live.detail;
    }
  },
  methods: {},
  components: {
    XHeader: __WEBPACK_IMPORTED_MODULE_0__components_XHeader_XHeader___default.a,
    InteractionList: __WEBPACK_IMPORTED_MODULE_2__components_Interaction_InteractionList___default.a,
    WechatShare: __WEBPACK_IMPORTED_MODULE_1__components_WechatShare_WechatShare___default.a
  }

});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_confirm_index_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_confirm_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_confirm_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_textarea_index_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_textarea_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_textarea_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_0_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  props: [],
  data: function data() {
    return {
      content: '',
      showConfirm: false,
      confirm_title: '',
      onConfirm: ''
    };
  },

  computed: {
    activityId: function activityId() {
      return this.$store.state.live.detail.Id;
    },
    url: function url() {
      return this.$route.params.pic;
    }
  },
  methods: {
    publish: function publish() {
      var _this = this;

      if (this.validate()) {
        this.$store.dispatch({
          type: 'interactionPublish',
          title: this.content,
          picture: this.url,
          activityId: this.activityId
        }).then(function (res) {
          if (res.status == 201) {
            _this.$vux.loading.show({
              text: '发布成功！'
            });
            setTimeout(function () {
              _this.$vux.loading.hide();
              _this.$router.go(-1);
            }, 1000);
          }
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    validate: function validate() {
      if (this.content.length == 0) {
        this.$vux.toast.show({
          type: 'text',
          width: '150px',
          text: '还没有填写内容呢~'
        });
        return false;
      }
      if (!this.url) {
        this.$vux.toast.show({
          type: 'text',
          width: '150px',
          text: '没有上传图片哦'
        });
        return false;
      }
      return true;
    },
    cancel: function cancel() {
      var _this2 = this;

      this.confirm_title = '确定放弃编辑的内容？';
      this.showConfirm = true;
      this.onConfirm = function () {
        return _this2.$router.go(-1);
      };
    }
  },
  watch: {
    $route: function $route() {
      this.content = '';
    }
  },
  components: {
    XTextarea: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_x_textarea_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_group_index_vue___default.a,
    Confirm: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_confirm_index_vue___default.a
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tab_Tab__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tab_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Tab_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_tools_date_format_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_tools_date_format_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_tools_date_format_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tab_tab_item_vue__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tab_tab_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_tab_tab_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Guide_Guide__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Guide_Guide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Guide_Guide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_XShot_XShot__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_XShot_XShot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_XShot_XShot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_video_player__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HeaderBar_HeaderBar__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HeaderBar_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_HeaderBar_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CountDown_CountDown__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CountDown_CountDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_CountDown_CountDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Title_Title__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Title_Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Title_Title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Scroller_Scroller__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Scroller_Scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Scroller_Scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Tips_Tips__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Tips_Tips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Tips_Tips__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AdBar_AdBar__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AdBar_AdBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_AdBar_AdBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Loading_Loading__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Loading_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Loading_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_FaceRecog_FaceRecog__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_FaceRecog_FaceRecog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_FaceRecog_FaceRecog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_WechatShare_WechatShare__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_WechatShare_WechatShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_WechatShare_WechatShare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_InfiniteScroller_InfiniteScroller__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_InfiniteScroller_InfiniteScroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_InfiniteScroller_InfiniteScroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_PassView_PassView__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_PassView_PassView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_PassView_PassView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_mutation_types_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Previewer_Previewer__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Previewer_Previewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Previewer_Previewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vux_src_components_popup_index_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vux_src_components_popup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vux_src_tools_base64_index_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vux_src_tools_base64_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vux_src_tools_base64_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__api_api__ = __webpack_require__(6);



























__webpack_require__(485);
__webpack_require__(486);
/* harmony default export */ __webpack_exports__["default"] = ({
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_19_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  data: function data() {
    return {
      isFixed: false,
      showDetail: false,
      pageSize: 50,
      category: [],
      tab_index: 0,
      videoUrl: '',
      message_pic: 0,
      categoryId: 0,
      viewCount: 0,
      showSticky: true,
      isVisited: false,
      pageData: [],
      hideAll: false,
      isShowLoading: true,
      loop: false,
      isLoad: true,
      shotArr: [],
      options: {
        bgOpacity: 0.9,
        loop: false,
        clickToCloseNonZoomable: false,
        tapToClose: false,
        errorMsg: '<div class="pswp__error-msg">哎呀，图片加载不出来了...</div>',
        isClickableElement: function isClickableElement(el) {
          if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
            return true;
          } else {
            return false;
          }
        }
      }
    };
  },

  computed: {
    showCountDown: function showCountDown() {
      var now = new Date().getTime();
      var begin = new Date(this.live.BeginAt).getTime();
      if (now > begin) {
        return false;
      } else {
        return true;
      }
    },
    locationUrl: function locationUrl() {
      return window.location.href;
    },
    showPass: function showPass() {
      if (this.live.EncryptEnabled) {
        var time = new Date(window.localStorage[this.live.Id]);
        if (time) {
          var now = new Date();
          if (now.getTime() - time.getTime() < 24 * 60 * 60 * 1000) {
            return false;
          } else {
            window.localStorage.removeItem(this.live.Id);
            return true;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    player: function player() {
      return this.$refs.videoPlayer.player;
    },
    playerOptions: function playerOptions() {
      return {
        muted: false,

        sources: [{
          withCredentials: false,
          type: 'application/x-mpegURL',
          src: this.videoUrl
        }],
        errorDisplay: false,
        height: 200,
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
        poster: this.live.Banner
      };
    },
    player2Options: function player2Options() {
      return {
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        errorDisplay: false,
        sources: [{
          type: 'video/mp4',
          src: this.live.BannerVideo
        }],
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          captionsButton: false,
          chaptersButton: false
        },
        height: 200,
        poster: this.live.Banner
      };
    },
    showOrder: function showOrder() {
      return this.live.ParticipatorDisabled;
    },
    showInteract: function showInteract() {
      return this.live.InteractDisabled;
    },
    viewHeight: function viewHeight() {
      return this.$store.state.base.viewHeight;
    },
    pageIndex: function pageIndex() {
      return this.$store.state.live.pageIndex;
    },
    picCount: function picCount() {
      return this.$store.state.live.detail.PublishPicturesCount;
    },
    live: function live() {
      return this.$store.state.live.detail;
    },
    photoList: function photoList() {
      if (this.$store.state.live.photoList) {
        if (this.$store.state.live.totalNum == this.$store.state.live.photoList.length) {
          this.isLoad = false;
        } else {
          this.isLoad = true;
        }
        return this.$store.state.live.photoList;
      }
    },
    previewerList: function previewerList() {
      return this.initPreviewPhotoList(this.photoList);
    },
    copyRightDisplay: function copyRightDisplay() {
      return this.$store.state.live.detail.CopyrightDisplay;
    }
  },
  components: {
    Popup: __WEBPACK_IMPORTED_MODULE_20_vux_src_components_popup_index_vue___default.a,
    Guide: __WEBPACK_IMPORTED_MODULE_3__components_Guide_Guide___default.a,
    HeaderBar: __WEBPACK_IMPORTED_MODULE_6__components_HeaderBar_HeaderBar___default.a,
    YpTitle: __WEBPACK_IMPORTED_MODULE_8__components_Title_Title___default.a,
    Scroller: __WEBPACK_IMPORTED_MODULE_9__components_Scroller_Scroller___default.a,
    Tips: __WEBPACK_IMPORTED_MODULE_10__components_Tips_Tips___default.a,
    InfiniteScroller: __WEBPACK_IMPORTED_MODULE_15__components_InfiniteScroller_InfiniteScroller___default.a,
    AdBar: __WEBPACK_IMPORTED_MODULE_11__components_AdBar_AdBar___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_12__components_Loading_Loading___default.a,
    WechatShare: __WEBPACK_IMPORTED_MODULE_14__components_WechatShare_WechatShare___default.a,
    Previewer: __WEBPACK_IMPORTED_MODULE_18__components_Previewer_Previewer___default.a,
    Tab: __WEBPACK_IMPORTED_MODULE_0__components_Tab_Tab___default.a,
    PassView: __WEBPACK_IMPORTED_MODULE_16__components_PassView_PassView___default.a,
    TabItem: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_tab_tab_item_vue___default.a,
    FaceRecog: __WEBPACK_IMPORTED_MODULE_13__components_FaceRecog_FaceRecog___default.a,
    videoPlayer: __WEBPACK_IMPORTED_MODULE_5_vue_video_player__["videoPlayer"],
    CountDown: __WEBPACK_IMPORTED_MODULE_7__components_CountDown_CountDown___default.a,
    XShot: __WEBPACK_IMPORTED_MODULE_4__components_XShot_XShot___default.a
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (to.name == 'liveDetail' && from.name == 'liveInteraction') {
        vm.isShowLoading = false;
      }
      vm.fetchLiveDetail();
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    window.removeEventListener('scroll', this.video_fix, false);
    window.removeEventListener('scroll', this.fn_scroll, false);

    next();
  },

  methods: {
    description: function description(text) {
      if (text) {
        return text.replace('\r\n', '<br/>');
      } else {
        return '';
      }
    },
    goHotView: function goHotView() {
      this.$vux.loading.show({
        text: '生成看点...'
      });
      this.$router.push({
        name: 'hotView'
      });
    },
    fresh_pic: function fresh_pic() {
      this.fetchData('all');

      this.tab_index = 0;
      this.message_pic = 0;
    },
    addPicture: function addPicture(url, pId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_22__api_api__["a" /* default */].live.getPhotoDetail(pId).then(function (item) {
        _this2.photoList.splice(0, 0, item);
      });
    },
    socketPushPhoto: function socketPushPhoto() {
      var _this = this;
      var liveId = this.live.Id;
      var domain = window.location.hostname == 'yun.aiyaopai.com' ? 'yunfront.aiyaopai.com' : 'yunfront.aiyaopai.com';

      var websocket = new WebSocket('wss://' + domain + '/ws/publishpicture?activityid=' + liveId);

      websocket.onopen = function (evt) {
        setInterval(function () {
          websocket.send('yaopaiLive');
        }, 10000);
      };
      websocket.onmessage = function (evt) {
        var obj = JSON.parse(evt.data);
        if (obj.Action == 'Inserted') {
          var url = obj.Url;
          var picId = obj.Id;

          _this.message_pic++;
        }
      };
      websocket.onclose = function (evt) {
        console.log('onclose', evt);
      };
      websocket.onerror = function (evt) {
        console.log('onerror', evt);
      };
    },
    shotClose: function shotClose() {
      this.$refs.infinite_scroller.checkCancel();
    },
    startShot: function startShot(arr) {
      this.$refs.x_shot.init(arr, this.live.Id);
    },
    cancelShot: function cancelShot() {
      this.hideAll = !this.hideAll;
    },
    choseShot: function choseShot() {
      this.$refs.infinite_scroller.toggleMode();

      this.hideAll = !this.hideAll;
    },
    initLoading: function initLoading() {
      var time = window.localStorage.getItem('loadingTime');
      var now = new Date();
      if (time) {
        if (now.getTime() - new Date(time).getTime() > 24 * 60 * 60 * 1000) {
          this.isShowLoading = true;

          window.localStorage.setItem('loadingTime', now);
        } else {
          this.isShowLoading = false;
        }
      } else {
        window.localStorage.setItem('loadingTime', now);
      }
    },
    playerReadied: function playerReadied(player) {
      var hls = player.tech({ IWillNotUseThisInPlugins: true }).hls;
      player.tech_.hls.xhr.beforeRequest = function (options) {
        return options;
      };
    },
    fetchData: function fetchData(categoryId) {
      this.shotClose();
      this.hideAll = false;
      this.$vux.loading.show({
        text: '加载中...'
      });

      window.scrollTo(0, document.getElementById('pic_live').offsetTop + 40);
      this.categoryId = categoryId;
      if (categoryId == 'all') {
        this.$store.commit({
          type: __WEBPACK_IMPORTED_MODULE_17__store_mutation_types_js__["c" /* live */].setPageIndex,
          index: 1
        });

        this.fetchLivePhotoList(this.pageIndex, null);
      } else {
        this.$store.commit({
          type: __WEBPACK_IMPORTED_MODULE_17__store_mutation_types_js__["c" /* live */].setPageIndex,
          index: 1
        });
        this.fetchLivePhotoList(this.pageIndex, categoryId);
      }
    },
    fetchCategory: function fetchCategory() {
      var _this3 = this;

      var liveId = this.$route.params.liveId;
      __WEBPACK_IMPORTED_MODULE_22__api_api__["a" /* default */].live.fetchCategory(liveId).then(function (res) {
        if (res && res.length > 0) {
          if (document.getElementById('sticky-bar')) {
            document.getElementById('sticky-bar').style.width = res.length * 100 + 'px';
          }
          _this3.category = res;
        } else {
          _this3.showSticky = false;
        }
      });
    },
    order: function order() {
      window.location.href = window.location.origin + '/static/invite/index.html?id=' + this.$route.params.liveId;
    },
    initPreviewPhotoList: function initPreviewPhotoList(list) {
      var _this4 = this;

      var preview_arr = [];
      if (list) {
        list.map(function (item, index) {
          var url = '';
          var originUrl = _this4.initOriginPic(item);

          if (_this4.copyRightDisplay) {
            url = _this4.initCopyrightQiniu(item);
          } else {
            url = _this4.initPreviewQiniu(item);
          }
          preview_arr.push({
            info: item,
            src: url,
            isOrigin: false,
            w: item.Width,
            h: item.Height,
            origin_url: originUrl
          });
        });
      }
      return preview_arr;
    },
    closeVideo: function closeVideo() {
      this.isFixed = false;
      window.removeEventListener('scroll', this.video_fix, false);
      document.getElementsByClassName('video-js')[0].style.height = '200px';
    },
    initOriginPic: function initOriginPic(live) {
      var new_url = '';
      if (live) {
        var img_watermark = __WEBPACK_IMPORTED_MODULE_21_vux_src_tools_base64_index_js___default.a.encode(this.$store.state.live.detail.Watermark || '');
        var encodeUrl = void 0;
        if (this.copyRightDisplay) {
          encodeUrl = encodeURIComponent('watermark/3/text/wqlZQU9QQUk=/font/5b6u6L2v6ZuF6buR/fontsize/800/fill/I0ZGRkZGRg==/dissolve/85/gravity/SouthWest/dx/20/dy/20/image/' + img_watermark + '/dissolve/90/gravity/SouthEast');
        } else {
          encodeUrl = encodeURIComponent('watermark/1/image/' + img_watermark + '/dissolve/90/gravity/SouthEast');
        }
        new_url = live.Url + '?' + encodeUrl;
      }
      return new_url;
    },
    initCopyrightQiniu: function initCopyrightQiniu(live) {
      var new_url = '';
      if (live) {
        var img_watermark = __WEBPACK_IMPORTED_MODULE_21_vux_src_tools_base64_index_js___default.a.encode(this.$store.state.live.detail.Watermark);

        var encodeUrl = void 0;
        encodeUrl = encodeURIComponent('imageslim|watermark/3/text/wqlZQU9QQUk=/font/5b6u6L2v6ZuF6buR/fontsize/500/fill/I0ZGRkZGRg==/dissolve/85/gravity/SouthWest/dx/20/dy/20/image/' + img_watermark + '/dissolve/90/gravity/SouthEast');
        new_url = live.Url + '?' + encodeUrl;
      }
      return new_url;
    },
    initPreviewQiniu: function initPreviewQiniu(live) {

      var watermark = __WEBPACK_IMPORTED_MODULE_21_vux_src_tools_base64_index_js___default.a.encode(this.$store.state.live.detail.Watermark);

      var encodeUrl = void 0;
      encodeUrl = encodeURIComponent('imageslim|watermark/1/image/' + watermark + '/dissolve/90/gravity/SouthEast');
      var url = live.Url + '?' + encodeUrl;
      return url;
    },
    getViewCount: function getViewCount(id) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_22__api_api__["a" /* default */].live.addViewCount(id).then(function (count) {
        _this5.viewCount = count.Result;
      });
    },
    fetchLiveDetail: function fetchLiveDetail() {
      var _this6 = this;

      this.$store.dispatch({
        type: 'getLiveDetail',
        liveId: this.$route.params.liveId,
        router: this.$router
      }).then(function () {
        document.title = _this6.live.Title;

        _this6.socketPushPhoto();
        _this6.$refs.wechat.fetch();

        _this6.getViewCount(_this6.live.Id);
        if (_this6.live.LiveEnabled) {
          __WEBPACK_IMPORTED_MODULE_22__api_api__["a" /* default */].live.getLivePushUrl(_this6.live.LivePullStreamUrl).then(function (res) {
            console.log('=======', res.data.Result);
            _this6.videoUrl = res.data.Result;
          }).catch(function (err) {
            console.log(err);
          });
        }
      });
    },
    video_fix: function video_fix() {
      if (this.live.LiveEnabled || this.live.BannerVideo) {
        if (window.scrollY >= 250 && !this.hideAll) {
          this.isFixed = true;
          document.getElementsByClassName('video-js')[0].style.height = '140px';
        } else {
          this.isFixed = false;
          document.getElementsByClassName('video-js')[0].style.height = '200px';
        }
      }
    },
    fn_scroll: function fn_scroll() {
      if (document.getElementById('header')) {
        if (window.scrollY >= document.documentElement.clientHeight) {
          document.getElementById('header').style.opacity = '0';
        } else {
          document.getElementById('header').style.opacity = '1';
        }
      }
      if (this.showSticky) {
        var top = document.getElementById('pic_live').offsetTop;
        if (window.scrollY >= top + 40) {
          if (document.getElementById('sticky-bar')) {
            document.getElementById('sticky-box').style.position = 'fixed';
            document.getElementById('sticky-copy').style.display = 'block';
          }
        } else {
          if (document.getElementById('sticky-bar')) {
            document.getElementById('sticky-box').style.position = 'relative';
            document.getElementById('sticky-copy').style.display = 'none';
          }
        }
      }
    },
    fetchLivePhotoList: function fetchLivePhotoList(index, categoryId) {
      var options = {};
      if (categoryId) {
        options = {
          categoryId: categoryId,
          liveId: this.$route.params.liveId,
          pageIndex: index,
          pageSize: this.pageSize
        };
      } else {
        options = {
          liveId: this.$route.params.liveId,
          pageIndex: index,
          pageSize: this.pageSize
        };
      }
      this.$store.dispatch({
        type: 'getPhotoList',
        option: options
      });
    },
    showLiveDesc: function showLiveDesc() {
      this.showDetail = true;
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    loadMore: function loadMore() {
      this.$store.commit({
        type: __WEBPACK_IMPORTED_MODULE_17__store_mutation_types_js__["c" /* live */].setPageIndex,
        index: ++this.pageIndex
      });

      if (this.categoryId == 'all') {
        this.fetchLivePhotoList(this.pageIndex, null);
      } else {
        this.fetchLivePhotoList(this.pageIndex, this.categoryId);
      }
    }
  },

  mounted: function mounted() {
    if (window.localStorage.visited) {
      if (JSON.parse(window.localStorage.visited)) {
        this.isVisited = true;
      }
    }

    this.fetchCategory();

    if (this.$store.state.live.photoList.length == 0) {
      this.fetchLivePhotoList(this.pageIndex, null);
    }

    window.addEventListener('scroll', this.video_fix, false);
    window.addEventListener('scroll', this.fn_scroll, false);
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_XHeader_XHeader__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_XHeader_XHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_XHeader_XHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_XPreview_UPreview__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_XPreview_UPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_XPreview_UPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(7);







/* harmony default export */ __webpack_exports__["default"] = ({
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_4_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  props: [],
  data: function data() {
    return {
      currentIndex: 0,
      scrollDisabled: false,
      interactionList: [],
      liveId: 0,
      pageIndex: 1,
      pageSize: 10,
      loadMessage: '努力加载中 ...',
      previewerList: [],
      options: {
        bgOpacity: 0.9,
        loop: false,
        clickToCloseNonZoomable: false,
        tapToClose: false,
        isClickableElement: function isClickableElement(el) {
          if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
            return true;
          } else {
            return false;
          }
        },
        errorMsg: '<div class="pswp__error-msg">哎呀，图片加载不出来了...</div>'
      }
    };
  },

  computed: {
    list: function list() {
      return this.$store.state.live.currentUserInteractionList.Result;
    },
    interactionCount: function interactionCount() {
      return this.$store.state.live.currentUserInteractionList.Total;
    },
    params: function params() {
      return this.$route.params;
    }
  },
  methods: {
    direct: function direct(id) {
      this.$router.push({
        name: 'userInteractionDetail',
        params: { liveId: this.params.liveId, interactionId: id }
      });
    },
    refresh: function refresh() {
      this.$vux.loading.show({
        text: '正在加载...'
      });
      this.interactionList = [];
      this.pageIndex = 1;
      this.loadMessage = '努力加载中...';
      this.fetchInteraction();
    },
    show: function show(url, index, id) {
      var new_url = encodeURIComponent(url);
      var width = document.getElementById(index).width;
      var height = document.getElementById(index).height;

      this.previewerList = [];
      var item = {
        'w': width * 3,
        'h': height * 3,
        'src': url
      };
      this.currentIndex = index;
      this.previewerList.push(item);
      this.$refs.previewer.show(item, id);
    },
    dateFormat: function dateFormat(time) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(time).format('MM月DD日 HH:mm');
    },
    fetchInteraction: function fetchInteraction() {
      var _this = this;

      this.$store.dispatch({
        type: 'getUserInteractionList',
        liveId: this.liveId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        userId: JSON.parse(window.localStorage.user).Id
      }).then(function () {
        _this.list.map(function (item) {
          _this.interactionList.push(item);
        });

        _this.$nextTick(function () {
          _this.scrollDisabled = false;
          _this.$vux.loading.hide();
        });
      });
    },
    loadMore: function loadMore() {
      if (!this.scrollDisabled && document.documentElement.offsetHeight != 0 && document.documentElement.clientHeight + window.scrollY >= document.documentElement.offsetHeight) {
        this.scrollDisabled = true;

        if (this.interactionList.length < this.interactionCount) {
          this.pageIndex++;
          this.fetchInteraction();
        } else {
          this.loadMessage = '';
        }
      }
    }
  },
  watch: {
    $route: 'refresh'
  },
  components: {
    XHeader: __WEBPACK_IMPORTED_MODULE_0__components_XHeader_XHeader___default.a,
    Previewer: __WEBPACK_IMPORTED_MODULE_3__components_XPreview_UPreview___default.a,
    WechatShare: __WEBPACK_IMPORTED_MODULE_2__components_WechatShare_WechatShare___default.a
  },
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '正在加载...'
    });

    window.addEventListener('scroll', this.loadMore, false);

    this.liveId = this.$route.params.liveId;

    this.fetchInteraction();
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  components: {}
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_XPreview_XPreview__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_XPreview_XPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_XPreview_XPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_directives_transfer_dom_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_popup_index_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_popup_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_popup_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_group_index_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vux_src_components_group_index_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  directives: {
    TransferDom: __WEBPACK_IMPORTED_MODULE_4_vux_src_directives_transfer_dom_index_js__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      interact: {
        isLiked: false,
        data: {
          ActivityId: '',
          CreatedAt: '',
          Id: '',
          LikesCount: 0,
          Picture: '',
          Title: '',
          User: {
            Avatar: '',
            Nickname: ''
          },
          UserId: 0
        }
      },

      likeDisabled: false,
      loadFinished: false,
      likePageIndex: 1,
      commentPageIndex: 1,
      likeInfo: {
        list: [],
        count: 0,
        page: 0,
        index: 0
      },
      commentInfo: {
        list: [],
        count: 0,
        page: 0,
        index: 0
      },
      interactionId: '',
      showConfirm: false,
      confirm_title: '',
      onConfirm: '',
      isAct: false,
      pageIndex: 1,
      pageSize: 5,
      liveId: 0,
      content: '',
      currentCommentId: '',
      currentCommentIndex: 0,
      showComment: false
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'commentPageIndex', 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'interactionList', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'scrollDisabled', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loadMessage', '努力加载中 ...'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'previewerList', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'options', {
      bgOpacity: 0.9,
      loop: false,
      clickToCloseNonZoomable: false,
      tapToClose: false,
      isClickableElement: function isClickableElement(el) {
        if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
          return true;
        } else {
          return false;
        }
      },
      errorMsg: '<div class="pswp__error-msg">哎呀，图片加载不出来了...</div>'
    }), _ref;
  },

  components: {
    Previewer: __WEBPACK_IMPORTED_MODULE_3__components_XPreview_XPreview___default.a,
    Popup: __WEBPACK_IMPORTED_MODULE_6_vux_src_components_popup_index_vue___default.a,
    XButton: __WEBPACK_IMPORTED_MODULE_7_vux_src_components_x_button_index_vue___default.a,
    XTextarea: __WEBPACK_IMPORTED_MODULE_8_vux_src_components_x_textarea_index_vue___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_9_vux_src_components_group_index_vue___default.a,
    Confirm: __WEBPACK_IMPORTED_MODULE_5_vux_src_components_confirm_index_vue___default.a
  },
  computed: {},
  methods: {
    onCancel: function onCancel() {
      console.log('on cancel');
    },
    onHide: function onHide() {
      console.log('on hide');
    },
    onShow: function onShow() {
      console.log('on show');
    },
    remove: function remove(id) {
      var _this = this;

      this.confirm_title = '确定删除该作品？';
      this.showConfirm = true;
      this.onConfirm = function () {
        __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].live.removeInteraction(_this.interact.data.Id).then(function () {
          _this.$vux.toast.show({
            time: '1000',
            text: '删除成功'
          });

          _this.showComment = false;
          _this.$router.go(-1);
        });
      };
    },
    like: function like(id, index) {
      var _this2 = this;

      var u = JSON.parse(window.localStorage.user);
      if (!this.likeDisabled) {
        this.likeDisabled = true;

        if (this.interact.isLiked) {
          __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].live.unLike(id).then(function () {
            _this2.$vux.toast.show({
              text: '已取消赞'
            });

            _this2.interact.isLiked = false;

            _this2.likeInfo.count--;

            var rmIndex = 0;
            _this2.likeInfo.list.map(function (item, i) {
              if (item.Id == u.Id) {
                rmIndex = i;
              }
            });
            _this2.likeInfo.list.splice(rmIndex, 1);
            setTimeout(function () {
              _this2.likeDisabled = false;
            }, 2000);
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].live.like(id).then(function () {
            _this2.$vux.toast.show({
              text: '已赞'
            });

            _this2.interact.isLiked = true;

            _this2.likeInfo.count++;

            _this2.likeInfo.list.unshift({
              Nickname: u.Nickname,
              Avatar: u.Avatar
            });
            setTimeout(function () {
              _this2.likeDisabled = false;
            }, 2000);
          });
        }
      }
    },
    comment: function comment(id, index) {
      this.content = '';
      this.currentCommentId = id;
      this.currentCommentIndex = index;
      this.showComment = true;
    },
    touch: function touch() {
      this.isAct = true;
    },
    touchend: function touchend() {
      this.isAct = false;
    },
    loadComment: function loadComment() {
      var _this3 = this;

      if (this.commentPageIndex < this.commentInfo.page) {
        this.commentPageIndex++;

        __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].live.getInteractionCommentList(this.interactionId, this.commentPageIndex, 10).then(function (res) {
          if (res.data.Result.length > 0) {
            res.data.Result.map(function (item) {
              _this3.commentInfo.list.push(item);
            });
          }
        });
      }
    },
    show: function show(url) {
      var new_url = encodeURIComponent(url);
      var width = document.getElementById('pre').width;
      var height = document.getElementById('pre').height;

      this.previewerList = [];
      var item = {
        'w': width * 10,
        'h': height * 10,
        'src': url
      };
      this.previewerList.push(item);
      this.$refs.previewer.show(item);
    },
    publish: function publish() {
      var _this4 = this;

      var u = JSON.parse(window.localStorage.user);
      if (this.validate()) {
        __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].live.addComment(this.currentCommentId, this.content).then(function (cid) {
          _this4.commentInfo.list.push({
            Id: cid,
            Content: _this4.content,
            UserId: u.Id,
            User: {
              Nickname: u.Nickname,
              Avatar: u.Avatar
            }
          });

          _this4.commentInfo.count++;

          _this4.showComment = false;
        });
      }
    },
    validate: function validate() {
      if (this.content.length == 0) {
        this.$vux.toast.show({
          type: 'text',
          width: '150px',
          text: '您还没有填写内容哦~'
        });
        return false;
      }
      return true;
    },
    cancel: function cancel() {
      var _this5 = this;

      this.confirm_title = '确定放弃编辑的内容？';
      this.showConfirm = true;
      this.onConfirm = function () {
        return _this5.showComment = false;
      };
    },
    fetchInteraction: function fetchInteraction() {
      var _this6 = this;

      var u = JSON.parse(window.localStorage.user);

      __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].live.getInteractionDetail(this.interactionId, function (res) {
        if (res.status == 200) {
          _this6.interact.data = res.data;

          __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].live.checkLike(u.Id, _this6.interactionId).then(function (isLiked) {
            _this6.interact.isLiked = isLiked;

            __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].live.getInteractionLikeList(_this6.interactionId, _this6.likePageIndex, 20).then(function (data) {
              _this6.likeInfo.page = data.data.PageCount;
              _this6.likeInfo.index = data.data.PageIndex;
              _this6.likeInfo.count = data.data.Total;
              data.data.Result.map(function (item) {
                _this6.likeInfo.list.push(item);
              });

              __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].live.getInteractionCommentList(_this6.interactionId, _this6.commentPageIndex, 10).then(function (data) {
                _this6.commentInfo.page = data.data.PageCount;
                _this6.commentInfo.index = data.data.PageIndex;
                _this6.commentInfo.count = data.data.Total;
                data.data.Result.map(function (item) {
                  _this6.commentInfo.list.push(item);
                });

                _this6.loadFinished = true;
                _this6.$vux.loading.hide();
              });
            });
          });
        }
      });
    },
    dateFormat: function dateFormat(time) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(time).format('MM月DD日 HH:mm');
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {

      vm.commentInfo = { list: [] };
      vm.likeInfo = { list: [] };
      vm.interact = { isLiked: false };
      vm.likePageIndex = 1;
      vm.commentPageIndex = 1;
      vm.loadFinished = false;
      vm.interactionId = vm.$route.params.interactionId;
      vm.fetchInteraction();
    });
  },
  mounted: function mounted() {
    this.$vux.loading.show({
      text: '正在加载中...'
    });
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  data: function data() {
    return {};
  },

  computed: {},
  methods: {},
  components: {}
});

/***/ }),
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 114,
	"./af.js": 114,
	"./ar": 121,
	"./ar-dz": 115,
	"./ar-dz.js": 115,
	"./ar-kw": 116,
	"./ar-kw.js": 116,
	"./ar-ly": 117,
	"./ar-ly.js": 117,
	"./ar-ma": 118,
	"./ar-ma.js": 118,
	"./ar-sa": 119,
	"./ar-sa.js": 119,
	"./ar-tn": 120,
	"./ar-tn.js": 120,
	"./ar.js": 121,
	"./az": 122,
	"./az.js": 122,
	"./be": 123,
	"./be.js": 123,
	"./bg": 124,
	"./bg.js": 124,
	"./bm": 125,
	"./bm.js": 125,
	"./bn": 126,
	"./bn.js": 126,
	"./bo": 127,
	"./bo.js": 127,
	"./br": 128,
	"./br.js": 128,
	"./bs": 129,
	"./bs.js": 129,
	"./ca": 130,
	"./ca.js": 130,
	"./cs": 131,
	"./cs.js": 131,
	"./cv": 132,
	"./cv.js": 132,
	"./cy": 133,
	"./cy.js": 133,
	"./da": 134,
	"./da.js": 134,
	"./de": 137,
	"./de-at": 135,
	"./de-at.js": 135,
	"./de-ch": 136,
	"./de-ch.js": 136,
	"./de.js": 137,
	"./dv": 138,
	"./dv.js": 138,
	"./el": 139,
	"./el.js": 139,
	"./en-au": 140,
	"./en-au.js": 140,
	"./en-ca": 141,
	"./en-ca.js": 141,
	"./en-gb": 142,
	"./en-gb.js": 142,
	"./en-ie": 143,
	"./en-ie.js": 143,
	"./en-nz": 144,
	"./en-nz.js": 144,
	"./eo": 145,
	"./eo.js": 145,
	"./es": 148,
	"./es-do": 146,
	"./es-do.js": 146,
	"./es-us": 147,
	"./es-us.js": 147,
	"./es.js": 148,
	"./et": 149,
	"./et.js": 149,
	"./eu": 150,
	"./eu.js": 150,
	"./fa": 151,
	"./fa.js": 151,
	"./fi": 152,
	"./fi.js": 152,
	"./fo": 153,
	"./fo.js": 153,
	"./fr": 156,
	"./fr-ca": 154,
	"./fr-ca.js": 154,
	"./fr-ch": 155,
	"./fr-ch.js": 155,
	"./fr.js": 156,
	"./fy": 157,
	"./fy.js": 157,
	"./gd": 158,
	"./gd.js": 158,
	"./gl": 159,
	"./gl.js": 159,
	"./gom-latn": 160,
	"./gom-latn.js": 160,
	"./gu": 161,
	"./gu.js": 161,
	"./he": 162,
	"./he.js": 162,
	"./hi": 163,
	"./hi.js": 163,
	"./hr": 164,
	"./hr.js": 164,
	"./hu": 165,
	"./hu.js": 165,
	"./hy-am": 166,
	"./hy-am.js": 166,
	"./id": 167,
	"./id.js": 167,
	"./is": 168,
	"./is.js": 168,
	"./it": 169,
	"./it.js": 169,
	"./ja": 170,
	"./ja.js": 170,
	"./jv": 171,
	"./jv.js": 171,
	"./ka": 172,
	"./ka.js": 172,
	"./kk": 173,
	"./kk.js": 173,
	"./km": 174,
	"./km.js": 174,
	"./kn": 175,
	"./kn.js": 175,
	"./ko": 176,
	"./ko.js": 176,
	"./ky": 177,
	"./ky.js": 177,
	"./lb": 178,
	"./lb.js": 178,
	"./lo": 179,
	"./lo.js": 179,
	"./lt": 180,
	"./lt.js": 180,
	"./lv": 181,
	"./lv.js": 181,
	"./me": 182,
	"./me.js": 182,
	"./mi": 183,
	"./mi.js": 183,
	"./mk": 184,
	"./mk.js": 184,
	"./ml": 185,
	"./ml.js": 185,
	"./mr": 186,
	"./mr.js": 186,
	"./ms": 188,
	"./ms-my": 187,
	"./ms-my.js": 187,
	"./ms.js": 188,
	"./my": 189,
	"./my.js": 189,
	"./nb": 190,
	"./nb.js": 190,
	"./ne": 191,
	"./ne.js": 191,
	"./nl": 193,
	"./nl-be": 192,
	"./nl-be.js": 192,
	"./nl.js": 193,
	"./nn": 194,
	"./nn.js": 194,
	"./pa-in": 195,
	"./pa-in.js": 195,
	"./pl": 196,
	"./pl.js": 196,
	"./pt": 198,
	"./pt-br": 197,
	"./pt-br.js": 197,
	"./pt.js": 198,
	"./ro": 199,
	"./ro.js": 199,
	"./ru": 200,
	"./ru.js": 200,
	"./sd": 201,
	"./sd.js": 201,
	"./se": 202,
	"./se.js": 202,
	"./si": 203,
	"./si.js": 203,
	"./sk": 204,
	"./sk.js": 204,
	"./sl": 205,
	"./sl.js": 205,
	"./sq": 206,
	"./sq.js": 206,
	"./sr": 208,
	"./sr-cyrl": 207,
	"./sr-cyrl.js": 207,
	"./sr.js": 208,
	"./ss": 209,
	"./ss.js": 209,
	"./sv": 210,
	"./sv.js": 210,
	"./sw": 211,
	"./sw.js": 211,
	"./ta": 212,
	"./ta.js": 212,
	"./te": 213,
	"./te.js": 213,
	"./tet": 214,
	"./tet.js": 214,
	"./th": 215,
	"./th.js": 215,
	"./tl-ph": 216,
	"./tl-ph.js": 216,
	"./tlh": 217,
	"./tlh.js": 217,
	"./tr": 218,
	"./tr.js": 218,
	"./tzl": 219,
	"./tzl.js": 219,
	"./tzm": 221,
	"./tzm-latn": 220,
	"./tzm-latn.js": 220,
	"./tzm.js": 221,
	"./uk": 222,
	"./uk.js": 222,
	"./ur": 223,
	"./ur.js": 223,
	"./uz": 225,
	"./uz-latn": 224,
	"./uz-latn.js": 224,
	"./uz.js": 225,
	"./vi": 226,
	"./vi.js": 226,
	"./x-pseudo": 227,
	"./x-pseudo.js": 227,
	"./yo": 228,
	"./yo.js": 228,
	"./zh-cn": 229,
	"./zh-cn.js": 229,
	"./zh-hk": 230,
	"./zh-hk.js": 230,
	"./zh-tw": 231,
	"./zh-tw.js": 231
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 468;

/***/ }),
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Search failure@2x.0b06910.png";

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/findmyself@2x.6a31e7a.png";

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tryagain_icon@2x.1ecd7cf.png";

/***/ }),
/* 485 */,
/* 486 */,
/* 487 */
/***/ (function(module, exports) {

module.exports = {
	"_from": "videojs-swf@5.4.1",
	"_id": "videojs-swf@5.4.1",
	"_inBundle": false,
	"_integrity": "sha1-IHfvccdJ8seCPvSbq65N0qywj4c=",
	"_location": "/videojs-swf",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "videojs-swf@5.4.1",
		"name": "videojs-swf",
		"escapedName": "videojs-swf",
		"rawSpec": "5.4.1",
		"saveSpec": null,
		"fetchSpec": "5.4.1"
	},
	"_requiredBy": [
		"/videojs-flash"
	],
	"_resolved": "http://registry.npm.taobao.org/videojs-swf/download/videojs-swf-5.4.1.tgz",
	"_shasum": "2077ef71c749f2c7823ef49babae4dd2acb08f87",
	"_spec": "videojs-swf@5.4.1",
	"_where": "/Users/stonemaker/Documents/coding/yaopai-live/node_modules/videojs-flash",
	"author": {
		"name": "Brightcove"
	},
	"bugs": {
		"url": "https://github.com/videojs/video-js-swf/issues"
	},
	"bundleDependencies": false,
	"copyright": "Copyright 2014 Brightcove, Inc. https://github.com/videojs/video-js-swf/blob/master/LICENSE",
	"deprecated": false,
	"description": "The Flash-fallback video player for video.js (http://videojs.com)",
	"devDependencies": {
		"async": "~0.2.9",
		"chg": "^0.3.2",
		"flex-sdk": "4.6.0-0",
		"grunt": "~0.4.0",
		"grunt-bumpup": "~0.5.0",
		"grunt-cli": "~0.1.0",
		"grunt-connect": "~0.2.0",
		"grunt-contrib-jshint": "~0.4.3",
		"grunt-contrib-qunit": "~0.2.1",
		"grunt-contrib-watch": "~0.1.4",
		"grunt-npm": "~0.0.2",
		"grunt-prompt": "~0.1.2",
		"grunt-shell": "~0.6.1",
		"grunt-tagrelease": "~0.3.1",
		"qunitjs": "~1.12.0",
		"video.js": "^5.9.2"
	},
	"homepage": "http://videojs.com",
	"keywords": [
		"flash",
		"video",
		"player"
	],
	"name": "videojs-swf",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/videojs/video-js-swf.git"
	},
	"scripts": {
		"version": "chg release -y && grunt dist && git add -f dist/ && git add CHANGELOG.md"
	},
	"version": "5.4.1"
};

/***/ }),
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('section', {
    staticClass: "pass-view"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("本场活动需要密码访问")]), _vm._v(" "), _c('input', {
    staticClass: "text-input",
    attrs: {
      "id": "pass",
      "autofocus": "",
      "type": "text",
      "maxlength": "6",
      "placeholder": "请输入访问密码"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.enter
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-xiangyou1"
    }
  })])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "adBar",
    staticClass: "footer"
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://live.aiyaopai.com/static/order_v2/index.html"
    }
  }, [_c('img', {
    staticClass: "footerIamge",
    attrs: {
      "src": "https://assets.aiyaopai.com/ad_2018.gif",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "weui-btn",
    class: _vm.classes,
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.actionType
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.showLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)
},staticRenderFns: []}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-tab-item",
    class: [_vm.currentSelected ? _vm.activeClass : '', {
      'vux-tab-selected': _vm.currentSelected,
      'vux-tab-disabled': _vm.disabled
    }],
    style: (_vm.style),
    on: {
      "click": _vm.onItemClick
    }
  }, [_vm._t("default"), _vm._v(" "), (typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '') ? _c('span', {
    staticClass: "vux-tab-item-badge",
    style: ({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })
  }, [_vm._v(_vm._s(_vm.badgeLabel))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": _vm.back
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-xiangzuo1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title ? _vm.title : '现场互动'))]), _vm._v(" "), (_vm.upload) ? _c('div', {
    ref: "pickfiles",
    staticClass: "right",
    attrs: {
      "id": "pickfiles"
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-xiangjicopy"
    }
  })])]) : _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticStyle: {
      "padding": "0 15px",
      "width": "22px",
      "height": "40px"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    attrs: {
      "position": "left"
    },
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "200px"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      backgroundImage: ("url('" + (_vm.user.Avatar) + "')")
    })
  }), _vm._v(" "), _c('h1', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.user.Nickname))])]), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "is-link": "",
      "link": "https://yun.aiyaopai.com/static/home/index.html",
      "title": "云摄影主页"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "is-link": "",
      "link": "https://yun.aiyaopai.com/static/home/moreImg/index.html",
      "title": "更多活动现场"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "is-link": "",
      "link": "https://yun.aiyaopai.com/static/order/recruit.html",
      "title": "成为云摄影师"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "is-link": "",
      "link": "https://yun.aiyaopai.com/static/order/index.html",
      "title": "预约云摄影"
    }
  })], 1)], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": ("vux-popup-animate-" + _vm.position)
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && !_vm.initialShow),
      expression: "show && !initialShow"
    }],
    staticClass: "vux-popup-dialog",
    class: [("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],
    style: (_vm.styles)
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp vux-previewer",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "pswp__bg"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-close"
    }
  })])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "https://loading.io/spinners/microsoft/index.svg",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pic-info"
  }, [_c('p', {
    staticClass: "time"
  }, [_vm._v("\n      拍摄时间：" + _vm._s(_vm.pic_time))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pic_title),
      expression: "pic_title"
    }],
    staticClass: "description"
  }, [_c('p', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.pic_title)
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-info"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "origin"
  }, [_c('span', {
    staticClass: "page"
  }, [_vm._v(_vm._s(_vm.current) + " / " + _vm._s(_vm.total))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isOrigin),
      expression: "!isOrigin"
    }],
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showOrigin(_vm.current)
      }
    }
  }, [_vm._v("查看原图(" + _vm._s(_vm.pic_size) + "K)")]), _vm._v(" "), _c('span', {
    staticClass: "download",
    on: {
      "click": function($event) {
        _vm.showPosition('middle')
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-download"
    }
  })])])]), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": 1500,
      "is-show-mask": "",
      "text": "长按图片保存",
      "position": _vm.position
    },
    model: {
      value: (_vm.showPositionValue),
      callback: function($$v) {
        _vm.showPositionValue = $$v
      },
      expression: "showPositionValue"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__scroll-wrap"
  }, [_c('div', {
    staticClass: "pswp__container"
  }, [_c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pswp__ui pswp__ui--hidden",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "pswp__top-bar"
  }, [_c('div', {
    staticClass: "pswp__counter"
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--close",
    attrs: {
      "title": "Close (Esc)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--share",
    attrs: {
      "title": "Share"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--fs",
    attrs: {
      "title": "Toggle fullscreen"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--zoom",
    attrs: {
      "title": "Zoom in/out"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__preloader"
  }, [_c('div', {
    staticClass: "pswp__preloader__icn"
  }, [_c('div', {
    staticClass: "pswp__preloader__cut"
  }, [_c('div', {
    staticClass: "pswp__preloader__donut"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
  }, [_c('div', {
    staticClass: "pswp__share-tooltip"
  })]), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--left",
    attrs: {
      "title": "Previous (arrow left)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--right",
    attrs: {
      "title": "Next (arrow right)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__caption"
  }, [_c('div', {
    staticClass: "pswp__caption__center"
  })])])])
}]}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "face-page"
  }, [_c('div', {
    staticClass: "face-search",
    on: {
      "click": _vm.showUpPanel
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-panel",
    class: {
      'hidden': !_vm.showUpload
    }
  }, [_c('div', {
    staticClass: "panel",
    attrs: {
      "id": "faceRecog"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('upload', {
    ref: "upload",
    attrs: {
      "pId": "face_con",
      "bId": "face_pic",
      "cb": _vm.uploaded
    }
  }, [_c('div', {
    staticClass: "qiniu",
    slot: "upload"
  }, [_c('img', {
    staticClass: "upload",
    attrs: {
      "width": "70%",
      "src": __webpack_require__(483),
      "alt": ""
    }
  })])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("\n  Live Index")])
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('x-header', {
    attrs: {
      "title": "我的现场",
      "upload": "true"
    }
  }), _vm._v(" "), (_vm.interactionList.length > 0) ? _c('div', {
    staticClass: "interactWrapper"
  }, [_c('ul', _vm._l((_vm.interactionList), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.direct(item.Id)
        }
      }
    }, [_c('h1', {
      staticClass: "datetime"
    }, [_vm._v(_vm._s(_vm.dateFormat(item.CreatedAt)))]), _vm._v(" "), _c('img', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "src": item.Picture + '?imageMogr2/thumbnail/20000@/auto-orient',
        "id": index,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "cover",
      style: ({
        backgroundImage: ("url('" + (item.Picture+'?imageMogr2/thumbnail/20000@/auto-orient') + "')")
      })
    }, [_c('div', {
      staticClass: "like"
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-ShapeCopy1"
      }
    })]), _vm._v(" " + _vm._s(item.LikesCount) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', [_vm._v(_vm._s(item.Title))])])])
  }))]) : _c('div', {
    staticClass: "qs"
  }, [_c('h1', [_vm._v("您还没有发布过作品")]), _vm._v(" "), _c('p', [_vm._v("点击右上角拍摄按钮上传作品吧~")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.previewerList,
      "data": _vm.interactionList,
      "index": _vm.currentIndex,
      "options": _vm.options
    },
    on: {
      "refresh": _vm.refresh
    }
  })], 1), _vm._v(" "), (_vm.interactionList.length > 0) ? _c('div', {
    staticClass: "loadTip"
  }, [_c('span', [_vm._v(_vm._s(_vm.loadMessage))])]) : _vm._e(), _vm._v(" "), _c('wechat-share', {
    attrs: {
      "title": "个人中心",
      "subTitle": "YAOPAI 实时影像云摄影",
      "shareImg": "http://aiyaopai.com/share.png"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n  "), (_vm.subTitle) ? _c('span', {
    staticClass: "subTitle"
  }, [_vm._v("查看详情")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-tab",
    class: {
      'vux-tab-no-animate': !_vm.animate
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.animate) ? _c('div', {
    staticClass: "vux-tab-ink-bar",
    class: _vm.barClass,
    style: (_vm.barStyle)
  }, [(_vm.customBarWidth) ? _c('span', {
    staticClass: "vux-tab-bar-inner",
    style: (_vm.innerBarStyle)
  }) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [(_vm.interactionList.length > 0) ? _c('div', {
    staticClass: "con"
  }, [_vm._l((_vm.interactionList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "p-wrapper"
    }, [_c('div', {
      staticClass: "wrapper"
    }, [_c('div', {
      staticClass: "avatar",
      style: ({
        backgroundImage: ("url('" + (item.User.Avatar) + "')")
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('h1', {
      staticClass: "nickName"
    }, [_vm._v(_vm._s(item.User.Nickname))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.dateFormat(item.CreatedAt)))])]), _vm._v(" "), _c('p', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.Title))]), _vm._v(" "), _c('div', {
      staticClass: "imgList",
      on: {
        "click": function($event) {
          _vm.show(item.Picture, index)
        }
      }
    }, [_c('img', {
      ref: "pic",
      refInFor: true,
      staticClass: "imgWrap",
      attrs: {
        "id": index,
        "width": "100%",
        "src": item.Picture + '?imageMogr2/thumbnail/20000@/auto-orient',
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "like"
    }, [_c('div', {
      staticClass: "like-wrapper",
      on: {
        "click": function($event) {
          _vm.like(item.Id, index)
        }
      }
    }, [(item.isLiked) ? _c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-ShapeCopy1"
      }
    })]) : _c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-like1"
      }
    })]), _vm._v(" " + _vm._s(item.LikesCount))]), _vm._v(" "), _c('div', {
      staticClass: "comment-wrapper",
      on: {
        "click": function($event) {
          _vm.comment(item.Id, index)
        }
      }
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-icon222"
      }
    })]), _vm._v(" " + _vm._s(item.commentInfo.data.Total) + "\n            ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "inter-detail"
    }, [(item.LikesCount > 0) ? _c('div', {
      staticClass: "like"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-like1"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "wrapper"
    }, _vm._l((item.likeInfo.data.Result), function(user, i) {
      return _c('img', {
        key: i,
        staticClass: "avatar",
        attrs: {
          "src": user.Avatar,
          "alt": ""
        }
      })
    }))]) : _vm._e(), _vm._v(" "), (item.commentInfo.data.Total > 0) ? _c('div', {
      staticClass: "comment"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-icon222"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "wrapper"
    }, [_c('ul', _vm._l((item.commentInfo.data.Result), function(comment, i) {
      return _c('li', {
        key: i
      }, [_c('img', {
        staticClass: "avatar",
        attrs: {
          "src": comment.User.Avatar,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('p', {
        staticClass: "nickName"
      }, [_vm._v(_vm._s(comment.User.Nickname))]), _vm._v(" "), _c('p', {
        staticClass: "content"
      }, [_vm._v(_vm._s(comment.Content))])])])
    }))])]) : _vm._e()]), _vm._v(" "), (item.commentInfo.data.Total > 10 && item.commentInfo.data.Result.length < item.commentInfo.data.Total) ? _c('div', {
      staticClass: "readMore",
      on: {
        "click": function($event) {
          _vm.loadComment(index, item.Id, item.commentInfo.data, 10)
        }
      }
    }, [_c('h1', {
      class: {
        'is-act': _vm.isAct
      },
      on: {
        "touchend": _vm.touchend,
        "touchstart": _vm.touch
      }
    }, [_vm._v("查看更多")])]) : _vm._e()])
  }), _vm._v(" "), (_vm.interactionList.length > 0) ? _c('div', {
    staticClass: "loadTip"
  }, [_c('span', [_vm._v(_vm._s(_vm.loadMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "position": "right"
    },
    model: {
      value: (_vm.showComment),
      callback: function($$v) {
        _vm.showComment = $$v
      },
      expression: "showComment"
    }
  }, [_c('div', {
    staticClass: "comment-header"
  }, [_c('h1', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('h1', {
    staticClass: "publish",
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("发表")])]), _vm._v(" "), _c('group', [_c('x-textarea', {
    attrs: {
      "height": 200,
      "rows": 8,
      "cols": 30,
      "placeholder": "请输入评论内容",
      "max": 1000
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.previewerList,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    attrs: {
      "title": _vm.confirm_title
    },
    on: {
      "on-cancel": _vm.onCancel,
      "on-confirm": _vm.onConfirm,
      "on-show": _vm.onShow,
      "on-hide": _vm.onHide
    },
    model: {
      value: (_vm.showConfirm),
      callback: function($$v) {
        _vm.showConfirm = $$v
      },
      expression: "showConfirm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fresh",
    on: {
      "click": _vm.fetchMore
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shuaxin2"
    }
  })])])], 2) : _c('section', {
    staticClass: "noData"
  }, [_c('h1', [_vm._v("暂无数据")])]), _vm._v(" "), _c('wechat-share', {
    attrs: {
      "title": _vm.live.Title,
      "subTitle": _vm.live.SubTitle,
      "shareImg": _vm.live.ShareLogo
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    staticClass: "container"
  }, [(_vm.flag == 'customer') ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: ("url( " + _vm.url + ")"),
      backgroundSize: (_vm.width + " " + _vm.height)
    })
  }, [_c('section', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.times) + " 秒后进入")])]) : (_vm.flag == 'def') ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: "url(/static/img/bg_mid.png)",
      backgroundSize: (_vm.width + " " + _vm.height)
    })
  }, [_c('section', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.times) + " 秒后进入")]), _vm._v(" "), _c('img', {
    staticClass: "gif",
    attrs: {
      "src": "/static/img/bg_top.gif",
      "width": "150",
      "alt": ""
    }
  })]) : _c('div', {
    staticClass: "loading"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "page"
    }
  }, [(!_vm.isVisited) ? _c('guide', {
    attrs: {
      "showInteract": !_vm.showInteract
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowLoading) ? _c('loading', {
    ref: "loading",
    attrs: {
      "delay": "3000",
      "liveData": _vm.live
    }
  }) : _vm._e(), _vm._v(" "), _c('header-bar', {
    staticClass: "header",
    attrs: {
      "title": _vm.live.Title,
      "id": "header"
    }
  }), _vm._v(" "), (!_vm.showInteract) ? _c('section', {
    staticClass: "interaction"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'liveInteraction',
        params: {
          liveId: this.$route.params.liveId
        }
      }
    }
  }, [_c('h1', [_vm._v("现场互动")])])], 1) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "first-screen"
    }
  }, [_c('section', {
    staticClass: "act-header"
  }, [(_vm.isFixed) ? _c('div', {
    staticStyle: {
      "min-height": "200px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "act-cover"
  }, [(_vm.live.ViewsEnable) ? _c('div', {
    staticClass: "viewCount"
  }, [_c('p', {
    staticClass: "text"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-view"
    }
  })]), _vm._v("\n            " + _vm._s(_vm.viewCount) + " 人收看过\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.live.LiveEnabled) ? _c('count-down') : _vm._e(), _vm._v(" "), (_vm.live.BannerExternalVideoUrl && !_vm.isFixed) ? _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.live.BannerExternalVideoUrl
    }
  }, [_vm._v(_vm._s(_vm.live.BannerExternalName ? _vm.live.BannerExternalName : '查看直播'))]) : _vm._e(), _vm._v(" "), (_vm.live.LiveEnabled) ? _c('div', {
    class: {
      fixVideo: _vm.isFixed && !_vm.hideAll
    }
  }, [(_vm.isFixed) ? _c('div', {
    staticClass: "close-video",
    on: {
      "click": _vm.closeVideo
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), _c('video-player', {
    staticClass: "vjs-custom-skin",
    attrs: {
      "options": _vm.playerOptions,
      "playsinline": true
    },
    on: {
      "ready": _vm.playerReadied
    }
  })], 1) : (_vm.live.BannerVideo) ? _c('div', {
    class: {
      fixVideo: _vm.isFixed && !_vm.hideAll
    },
    on: {
      "click": _vm.closeVideo
    }
  }, [(_vm.isFixed) ? _c('div', {
    staticClass: "close-video"
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), _c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "options": _vm.player2Options,
      "playsinline": true
    }
  })], 1) : _c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.live.Banner,
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "act-info"
  }, [_c('p', [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shizhongfill"
    }
  })]), _vm._v("\n          " + _vm._s(_vm.live.BeginAt.replace(/T/, ' ')) + " 至 " + _vm._s(_vm.live.EndAt.replace(/T/, ' ')) + "\n        ")]), _vm._v(" "), _c('p', [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-zuobiaofill"
    }
  })]), _vm._v("\n          " + _vm._s(_vm.live.Address) + "\n        ")])])]), _vm._v(" "), _c('yp-title', {
    attrs: {
      "text": _vm.live.SponsorTitle ? _vm.live.SponsorTitle : '相关品牌'
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "list": _vm.live.Sponsors
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "act-desc-panel",
    on: {
      "click": _vm.showLiveDesc
    }
  }, [_c('yp-title', {
    attrs: {
      "text": _vm.live.DescriptionTitle ? _vm.live.DescriptionTitle : '活动详情',
      "subTitle": "查看详情"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "act-description"
  }, [_vm._v("\n        " + _vm._s(_vm.live.Description) + "\n      ")])], 1), _vm._v(" "), _c('popup', {
    attrs: {
      "position": "bottom",
      "max-height": "50%"
    },
    model: {
      value: (_vm.showDetail),
      callback: function($$v) {
        _vm.showDetail = $$v
      },
      expression: "showDetail"
    }
  }, [_c('section', {
    staticClass: "live-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.description(_vm.live.Description))
    }
  })]), _vm._v(" "), (!_vm.showOrder && !_vm.hideAll) ? _c('tips', {
    staticClass: "tips",
    attrs: {
      "text": "上滑观看直播",
      "icon": "up"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showOrder) ? _c('div', {
    staticClass: "order",
    on: {
      "click": _vm.order
    }
  }, [_vm._v("立即报名")]) : _vm._e(), _vm._v(" "), (!_vm.showOrder) ? _c('section', {
    attrs: {
      "id": "second-screen"
    }
  }, [_c('yp-title', {
    staticClass: "list-title",
    attrs: {
      "text": "图片直播",
      "id": "pic_live"
    }
  }), _vm._v(" "), (_vm.showSticky) ? _c('div', {
    staticStyle: {
      "border-bottom": "1px solid #e5e5e5"
    },
    attrs: {
      "id": "sticky-box"
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated-4 fadeInDown",
      "leave-active-class": "animated-4 fadeOutUp"
    }
  }, [(_vm.message_pic > 0) ? _c('div', {
    staticClass: "fresh-tip",
    on: {
      "click": _vm.fresh_pic
    }
  }, [_vm._v("\n          " + _vm._s(_vm.message_pic) + " 张新图片，点击刷新\n          "), _c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shuaxin"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "overflow-x": "scroll",
      "overflow-y": "hidden",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "bar-active-color": "#ff9a00",
      "custom-bar-width": "120px",
      "line-width": 5,
      "id": "sticky-bar"
    },
    model: {
      value: (_vm.tab_index),
      callback: function($$v) {
        _vm.tab_index = $$v
      },
      expression: "tab_index"
    }
  }, [_c('tab-item', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "selected": ""
    },
    on: {
      "on-item-click": function($event) {
        _vm.fetchData('all')
      }
    }
  }, [_vm._v("全部(" + _vm._s(_vm.picCount) + ")")]), _vm._v(" "), _vm._l((_vm.category), function(item, index) {
    return _c('tab-item', {
      key: index,
      on: {
        "on-item-click": function($event) {
          _vm.fetchData(item.Id)
        }
      }
    }, [_vm._v(_vm._s(item.Name))])
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sticky-copy"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated-4 fadeInDown",
      "leave-active-class": "animated-4 fadeOutUp"
    }
  }, [_c('infinite-scroller', {
    ref: "infinite_scroller",
    attrs: {
      "photos": _vm.photoList,
      "isLoad": _vm.isLoad
    },
    on: {
      "cancelShot": _vm.cancelShot,
      "startShot": _vm.startShot,
      "loadMore": _vm.loadMore,
      "showPre": _vm.show
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.previewerList,
      "options": _vm.options
    },
    on: {
      "loadMore": _vm.loadMore
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPass) ? _c('pass-view', {
    attrs: {
      "id": _vm.live.Id,
      "pass": _vm.live.EncryptPassword
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.live.SubscribeDisabled && !_vm.hideAll) ? _c('ad-bar') : _vm._e(), _vm._v(" "), (_vm.live.JigsawEnabled) ? _c('x-shot', {
    ref: "x_shot",
    attrs: {
      "fn_close": _vm.shotClose,
      "url": _vm.locationUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 500,
        leave: 800
      },
      "enter-active-class": "animated bounceInRight",
      "leave-active-class": "animated bounceOutRight"
    }
  }, [(_vm.live.FaceEnabled && !_vm.hideAll) ? _c('face-recog') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 500,
        leave: 800
      },
      "enter-active-class": "animated bounceInRight",
      "leave-active-class": "animated bounceOutRight"
    }
  }, [(_vm.live.LargePictureSeparatedEnabled && !_vm.hideAll) ? _c('div', {
    staticClass: "hotview-button",
    on: {
      "click": _vm.goHotView
    }
  }, [_c('img', {
    attrs: {
      "src": "https://assets.aiyaopai.com/hotviews@2x.png",
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 500,
        leave: 800
      },
      "enter-active-class": "animated bounceInRight",
      "leave-active-class": "animated bounceOutRight"
    }
  }, [(_vm.live.JigsawEnabled && !_vm.hideAll) ? _c('div', {
    staticClass: "shot-button",
    on: {
      "click": _vm.choseShot
    }
  }, [_c('img', {
    attrs: {
      "src": "https://assets.aiyaopai.com/puzzle@2x.png",
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('wechat-share', {
    ref: "wechat",
    attrs: {
      "title": _vm.live.Title,
      "subTitle": _vm.live.SubTitle,
      "shareImg": _vm.live.ShareLogo
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadFinished) ? _c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "p-wrapper"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      backgroundImage: ("url('" + (_vm.interact.data.User.Avatar) + "')")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', {
    staticClass: "nickName"
  }, [_vm._v(_vm._s(_vm.interact.data.User.Nickname))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.interact.data.CreatedAt)))])]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.interact.data.Title))]), _vm._v(" "), _c('div', {
    staticClass: "imgList",
    on: {
      "click": function($event) {
        _vm.show(_vm.interact.data.Picture)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.interact.data.Picture + '?imageMogr2/thumbnail/20000@/auto-orient'),
      expression: "interact.data.Picture+'?imageMogr2/thumbnail/20000@/auto-orient'"
    }],
    ref: "pic",
    staticClass: "imgWrap",
    attrs: {
      "id": "pre",
      "width": "100%",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "like"
  }, [_c('div', {
    staticClass: "like-wrapper",
    on: {
      "click": function($event) {
        _vm.like(_vm.interact.data.Id, 0)
      }
    }
  }, [(_vm.interact.isLiked) ? _c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-ShapeCopy1"
    }
  })]) : _c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-like1"
    }
  })]), _vm._v(" " + _vm._s(_vm.likeInfo ? _vm.likeInfo.count : '22'))]), _vm._v(" "), _c('div', {
    staticClass: "comment-wrapper",
    on: {
      "click": function($event) {
        _vm.comment(_vm.interact.data.Id, 0)
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-icon222"
    }
  })]), _vm._v(" " + _vm._s(_vm.commentInfo.count) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "like-wrapper remove",
    on: {
      "click": function($event) {
        _vm.remove(_vm.interact.data.Id, 0)
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shanchu"
    }
  })]), _vm._v(" 删除\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "inter-detail"
  }, [(_vm.likeInfo.count > 0) ? _c('div', {
    staticClass: "like"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-like1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, _vm._l((_vm.likeInfo.list), function(user, i) {
    return _c('img', {
      key: i,
      staticClass: "avatar",
      attrs: {
        "src": user.Avatar,
        "alt": ""
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.commentInfo.count > 0) ? _c('div', {
    staticClass: "comment"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-icon222"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('ul', _vm._l((_vm.commentInfo.list), function(comment, i) {
    return _c('li', {
      key: i
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": comment.User.Avatar,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "nickName"
    }, [_vm._v(_vm._s(comment.User.Nickname))]), _vm._v(" "), _c('p', {
      staticClass: "content"
    }, [_vm._v(_vm._s(comment.Content))])])])
  }))])]) : _vm._e()]), _vm._v(" "), (_vm.commentInfo.list.length < _vm.commentInfo.count) ? _c('div', {
    staticClass: "readMore",
    on: {
      "click": _vm.loadComment
    }
  }, [_c('h1', {
    class: {
      'is-act': _vm.isAct
    },
    on: {
      "touchend": _vm.touchend,
      "touchstart": _vm.touch
    }
  }, [_vm._v("查看更多")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "position": "right"
    },
    model: {
      value: (_vm.showComment),
      callback: function($$v) {
        _vm.showComment = $$v
      },
      expression: "showComment"
    }
  }, [_c('div', {
    staticClass: "comment-header"
  }, [_c('h1', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('h1', {
    staticClass: "publish",
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("发表")])]), _vm._v(" "), _c('group', [_c('x-textarea', {
    attrs: {
      "height": 200,
      "rows": 8,
      "cols": 30,
      "placeholder": "请输入评论内容",
      "max": 1000
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.previewerList,
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    attrs: {
      "title": _vm.confirm_title
    },
    on: {
      "on-cancel": _vm.onCancel,
      "on-confirm": _vm.onConfirm,
      "on-show": _vm.onShow,
      "on-hide": _vm.onHide
    },
    model: {
      value: (_vm.showConfirm),
      callback: function($$v) {
        _vm.showConfirm = $$v
      },
      expression: "showConfirm"
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "gallery",
    staticClass: "container"
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          _vm.show(index)
        }
      }
    }, [(item.pic.IsLarge) ? _c('div', [_c('div', {
      staticClass: "loading",
      style: ({
        width: _vm.large_pic_width,
        height: _vm.large_pic_height
      })
    }, [(_vm.checkMode) ? _c('div', {
      staticClass: "chosePanel",
      class: {
        unchose: !_vm.isChecked(item.pic.Id), chosed: _vm.isChecked(item.pic.Id),
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.checkThis(item.pic.Id)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "bg-text"
    }, [_vm._v("YAOPAI 云摄影")]), _vm._v(" "), _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.url),
        expression: "item.url"
      }],
      staticClass: "pic previewer-demo-img",
      style: ({
        width: _vm.large_pic_width,
        minHeight: _vm.large_pic_height
      }),
      attrs: {
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "mask",
      domProps: {
        "innerHTML": _vm._s(item.pic.Title)
      }
    })]) : _c('div', {
      staticClass: "loading",
      style: ({
        width: _vm.pic_width,
        height: _vm.pic_height
      })
    }, [(_vm.checkMode) ? _c('div', {
      staticClass: "chosePanel",
      class: {
        unchose: !_vm.isChecked(item.pic.Id), chosed: _vm.isChecked(item.pic.Id),
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.checkThis(item.pic.Id)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "bg-text"
    }, [_vm._v("YAOPAI")]), _vm._v(" "), _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.url),
        expression: "item.url"
      }],
      staticClass: "pic previewer-demo-img",
      style: ({
        width: _vm.pic_width
      }),
      attrs: {
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('div', {
    ref: "tips",
    staticClass: "scrollTip"
  }, [_vm._v(_vm._s(_vm.isLoad ? '正在加载中...' : '没有更多了'))]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated-4 fadeInUp",
      "leave-active-class": "animated-4 fadeOutDown"
    }
  }, [(_vm.checkMode) ? _c('div', {
    staticClass: "check-panel"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": _vm.checkCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "fg"
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticClass: "ok",
    on: {
      "click": _vm.checkOK
    }
  }, [_vm._v("确定\n        "), (_vm.checkList.length > 0) ? _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.checkList.length))]) : _vm._e()])]) : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("\n  user interaction")])
},staticRenderFns: []}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMask && _vm.show),
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    })
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-dialog",
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui-mask",
    on: {
      "click": function($event) {
        _vm.hideOnBlur && (_vm.currentValue = false)
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    class: _vm.dialogClass,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp vux-previewer",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "pswp__bg"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-close"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__scroll-wrap"
  }, [_c('div', {
    staticClass: "pswp__container"
  }, [_c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pswp__ui pswp__ui--hidden",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "pswp__top-bar"
  }, [_c('div', {
    staticClass: "pswp__counter"
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--close",
    attrs: {
      "title": "Close (Esc)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--share",
    attrs: {
      "title": "Share"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--fs",
    attrs: {
      "title": "Toggle fullscreen"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--zoom",
    attrs: {
      "title": "Zoom in/out"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__preloader"
  }, [_c('div', {
    staticClass: "pswp__preloader__icn"
  }, [_c('div', {
    staticClass: "pswp__preloader__cut"
  }, [_c('div', {
    staticClass: "pswp__preloader__donut"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
  }, [_c('div', {
    staticClass: "pswp__share-tooltip"
  })]), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--left",
    attrs: {
      "title": "Previous (arrow left)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--right",
    attrs: {
      "title": "Next (arrow right)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__caption"
  }, [_c('div', {
    staticClass: "pswp__caption__center"
  })])])])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "face-page"
  }, [(_vm.faceList.length > 0) ? _c('section', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("YAOPAI为您找到" + _vm._s(_vm.faceList ? _vm.faceList.length : 0) + "张现场照片")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("点击查看大图，长按图片保存至手机相册")]), _vm._v(" "), _vm._l((_vm.faceList), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "face-item",
      attrs: {
        "src": item.Url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.show(index)
        }
      }
    })
  })], 2) : _c('section', {
    staticClass: "tip"
  }, [_c('img', {
    staticClass: "cov",
    attrs: {
      "src": __webpack_require__(482),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v("太低调了，找不到你的身影...")]), _vm._v(" "), _c('p', [_vm._v("上传正面大头最佳，非正面角度人物偏小都会影响精度，照片大小不超过2M")]), _vm._v(" "), _c('upload', {
    ref: "upload",
    attrs: {
      "pId": "face_cons",
      "bId": "face_pics",
      "cb": _vm.uploaded
    }
  }, [_c('div', {
    staticClass: "qiniu",
    slot: "upload"
  }, [_c('img', {
    staticClass: "upload",
    attrs: {
      "width": "50%",
      "src": __webpack_require__(484),
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.previewerList,
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell",
    class: {
      'vux-tap-active': _vm.isLink || !!_vm.link,
        'weui-cell_access': _vm.isLink || !!_vm.link,
        'vux-cell-no-border-intent': !_vm.borderIntent,
        'vux-cell-disabled': _vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-cell-bd",
    class: {
      'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'
    }
  }, [_c('p', [(_vm.title || _vm.hasTitleSlot) ? _c('label', {
    staticClass: "vux-label",
    style: (_vm.getLabelStyles())
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2) : _vm._e(), _vm._v(" "), _vm._t("after-title")], 2), _vm._v(" "), _c('inline-desc', [_vm._t("inline-desc", [_vm._v(_vm._s(_vm.inlineDesc))])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft",
    class: _vm.valueClass
  }, [_vm._t("value"), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), (_vm.isLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e()], 2), _vm._v(" "), _vm._t("child")], 2)
},staticRenderFns: []}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "wechat"
    }
  }, [_c('img', {
    staticClass: "sharePic",
    attrs: {
      "src": "",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-dialog', {
    attrs: {
      "dialogClass": _vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [(!!_vm.title) ? _c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))]), _vm._v(" "), _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onConfirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-container"
  }, [_c('ul', {
    staticClass: "s-wrap"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: item.Id,
      staticClass: "s-item",
      style: ({
        backgroundImage: ("url('" + (item.Logo) + "')")
      }),
      on: {
        "click": function($event) {
          _vm.showLogo(item)
        }
      }
    })
  })), _vm._v(" "), _c('popup', {
    attrs: {
      "position": "bottom",
      "max-height": "50%"
    },
    model: {
      value: (_vm.isShow),
      callback: function($$v) {
        _vm.isShow = $$v
      },
      expression: "isShow"
    }
  }, [_c('section', {
    staticClass: "detailPanel"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "Logo",
    attrs: {
      "src": _vm.itemInfo.Logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemInfo.QrCode),
      expression: "itemInfo.QrCode"
    }],
    staticClass: "qrcode",
    attrs: {
      "src": _vm.itemInfo.QrCode,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h1', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.itemInfo.Name))])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "guide",
    attrs: {
      "id": "guide"
    }
  }, [
    [_c('div', {
      staticClass: "g1",
      attrs: {
        "id": "g1"
      }
    }, [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.next(1)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "g2",
      attrs: {
        "id": "g2"
      }
    }, [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.next(2)
        }
      }
    })])]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "img-icon",
    attrs: {
      "src": "https://aiyaopai.com/404.png",
      "width": "200",
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v("页面找不到咯")]), _vm._v(" "), _c('p', [_vm._v("我猜是程序猿也去现场凑热闹了")])])
}]}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show_panel) ? _c('section', {
    attrs: {
      "id": "shot-con"
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-guanbicopyx"
    }
  })])]), _vm._v(" "), (_vm.show_loading) ? _c('section', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "https://assets.aiyaopai.com/5-160914192R5-50.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("正在努力拼图中...")])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "sec"
  }, [_c('img', {
    staticClass: "showPic",
    attrs: {
      "src": _vm.pic_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tip-button"
  }, [_vm._v("长按保存图片")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("\n  Home")])
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "title"
  }, [_vm._v("\n  " + _vm._s(_vm.title) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hot-container"
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "src": "https://assets.aiyaopai.com/Group%204@3x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "back-home",
    attrs: {
      "to": {
        name: 'liveDetail',
        params: {
          liveId: _vm.live.Id
        }
      }
    }
  }, [_vm._v("主页")]), _vm._v(" "), _c('section', {
    staticClass: "hot-view"
  }, [_vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.shot(item)
        }
      }
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": item.Url,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.Title))])])
  }), _vm._v(" "), _c('shot', {
    ref: "shot",
    attrs: {
      "url": _vm.url
    }
  }, [_c('div', {
    staticClass: "item-print"
  }, [_c('img', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": "https://assets.aiyaopai.com/Group%204@3x.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "wrap2"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.print.Url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.print.Title)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.live.Title))]), _vm._v(" "), _c('div', {
    staticClass: "qr"
  }, [_c('qrcode', {
    ref: "qrcode",
    attrs: {
      "size": 100,
      "value": _vm.url,
      "type": "img"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('p', [_vm._v("长按识别二维码")]), _vm._v(" "), _c('p', [_vm._v("获取更多精彩内容")])])])])])], 2), _vm._v(" "), _c('wechat-share', {
    ref: "wechat",
    attrs: {
      "title": '精彩看点 | ' + _vm.live.Title,
      "subTitle": _vm.live.SubTitle,
      "shareImg": _vm.live.ShareLogo
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('section', {
    staticClass: "count-down"
  }, [_c('div', {
    staticClass: "icons"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-video"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "info-wrapper"
  }, [_c('h2', [_vm._v("距离开播还有")]), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(_vm.countDown))])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "vux-label-desc"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "scrollTip",
    staticClass: "container"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.icon === 'up') ? _c('div', {
    staticClass: "triggle-icon"
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp vux-previewer",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "pswp__bg"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.interact) ? _c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "btnWrap",
    on: {
      "click": _vm.direct
    }
  }, [_c('div', {
    staticClass: "like-wrapper"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-like1"
    }
  })]), _vm._v(" " + _vm._s(_vm.interact.LikesCount) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "comment-wrapper"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-icon222"
    }
  })]), _vm._v(" " + _vm._s(_vm.interact.commentInfo.data.Total) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.interact.Title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "delete"
  }, [_c('div', {
    staticClass: "wrapper",
    on: {
      "click": _vm.remove
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shanchu"
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-close"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__scroll-wrap"
  }, [_c('div', {
    staticClass: "pswp__container"
  }, [_c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pswp__ui pswp__ui--hidden",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "pswp__top-bar"
  }, [_c('div', {
    staticClass: "pswp__counter"
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--close",
    attrs: {
      "title": "Close (Esc)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--share",
    attrs: {
      "title": "Share"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--fs",
    attrs: {
      "title": "Toggle fullscreen"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--zoom",
    attrs: {
      "title": "Zoom in/out"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__preloader"
  }, [_c('div', {
    staticClass: "pswp__preloader__icn"
  }, [_c('div', {
    staticClass: "pswp__preloader__cut"
  }, [_c('div', {
    staticClass: "pswp__preloader__donut"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
  }, [_c('div', {
    staticClass: "pswp__share-tooltip"
  })]), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--left",
    attrs: {
      "title": "Previous (arrow left)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--right",
    attrs: {
      "title": "Next (arrow right)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__caption"
  }, [_c('div', {
    staticClass: "pswp__caption__center"
  })])])])
}]}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show_panel) ? _c('section', {
    attrs: {
      "id": "shot-con"
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-guanbicopyx"
    }
  })])]), _vm._v(" "), (_vm.show_loading) ? _c('section', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "https://assets.aiyaopai.com/%E6%9C%AA%E6%A0%87%E9%A2%98-1.gif",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("生成分享卡片中...")])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "screen-shot",
    attrs: {
      "id": "shot"
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sec"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "hidepic"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "myCanvas"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "showPic",
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tip-button"
  }, [_vm._v("长按保存图片"), _c('br'), _vm._v("转发分享现场直播")])])
}]}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title) ? _c('div', {
    staticClass: "weui-cells__title",
    style: ({
      color: _vm.titleColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-cells",
    class: {
      'vux-no-group-title': !_vm.title
    },
    style: ({
      marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
    })
  }, [_vm._t("after-title"), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "vux-mask"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast"
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('x-header', {
    attrs: {
      "upload": "true"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'liveDetail',
        params: {
          liveId: this.$route.params.liveId
        }
      }
    }
  }, [_c('div', {
    staticClass: "backHome"
  }, [_c('h1', [_vm._v("主会场\n        "), _c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-jiantou1"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover",
    style: ({
      backgroundImage: ("url('" + (_vm.live.Banner) + "')")
    })
  }, [_c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "cc"
  }, [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-tongzhi"
    }
  })]), _vm._v(" "), _c('marquee', {
    attrs: {
      "id": "affiche",
      "align": "left",
      "behavior": "scroll",
      "direction": "left",
      "height": "16",
      "width": "100%",
      "hspace": "40",
      "vspace": "7",
      "loop": "loop",
      "scrollamount": "5",
      "scrolldelay": "100"
    }
  }, [_vm._v("\n          拍摄上传你认为的现场大片，参与现场互动\n        ")])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'userIndex',
        params: {
          liveId: this.$route.params.liveId
        }
      }
    }
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      backgroundImage: ("url('" + (_vm.user.Avatar) + "')")
    })
  })])], 1), _vm._v(" "), _c('interaction-list', {
    staticClass: "list"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("\n  user detail")])
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-player"
  }, [_c('video', {
    staticClass: "video-js"
  })])
}]}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'canvas'),
      expression: "type === 'canvas'"
    }],
    ref: "canvas",
    style: ({
      height: _vm.size,
      width: _vm.size
    }),
    attrs: {
      "height": _vm.size,
      "width": _vm.size
    }
  }), _vm._v(" "), (_vm.type === 'img') ? _c('img', {
    attrs: {
      "src": _vm.imgData
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('h1', {
    staticClass: "publish",
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("发布")])]), _vm._v(" "), _c('div', {
    staticClass: "editWrapper"
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "height": 100,
      "rows": 5,
      "cols": 30,
      "placeholder": "说说这张照片",
      "max": 1000
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    attrs: {
      "title": _vm.confirm_title
    },
    on: {
      "on-confirm": _vm.onConfirm
    },
    model: {
      value: (_vm.showConfirm),
      callback: function($$v) {
        _vm.showConfirm = $$v
      },
      expression: "showConfirm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "preview",
    style: ({
      backgroundImage: ("url(" + (_vm.url+'?imageMogr2/thumbnail/20000@/auto-orient') + ")")
    })
  })])
},staticRenderFns: []}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "upload-qiniu"
  }, [_c('div', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.pId
    }
  }, [_c('div', {
    staticClass: "btn",
    attrs: {
      "id": _vm.bId
    }
  }, [_vm._t("upload")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell vux-x-textarea"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [(_vm.hasRestrictedLabel) ? _c('div', {
    style: (_vm.labelStyles)
  }, [_vm._t("restricted-label")], 2) : _vm._e(), _vm._v(" "), _vm._t("label", [(_vm.title) ? _c('label', {
    staticClass: "weui-label",
    style: ({
      width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'),
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "textarea",
    staticClass: "weui-textarea",
    style: (_vm.textareaStyle),
    attrs: {
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "name": _vm.name,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "maxlength": _vm.max
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": function($event) {
        _vm.$emit('on-focus')
      },
      "blur": function($event) {
        _vm.$emit('on-blur')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCounter && _vm.max),
      expression: "showCounter && max"
    }],
    staticClass: "weui-textarea-counter",
    on: {
      "click": _vm.focus
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.count))]), _vm._v("/" + _vm._s(_vm.max) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  })
},staticRenderFns: []}

/***/ }),
/* 543 */,
/* 544 */,
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(495),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(508),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(402)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(504),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(415)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(518),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(431)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(497),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(493),
  /* scopeId */
  "data-v-0589f9f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(425)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(528),
  /* scopeId */
  "data-v-7cabaefa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(399)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(501),
  /* scopeId */
  "data-v-306abbee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(419)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(522),
  /* scopeId */
  "data-v-70dfa910",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(423)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(526),
  /* scopeId */
  "data-v-79f37ba4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(409)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(512),
  /* scopeId */
  "data-v-50c71ad6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(405)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(507),
  /* scopeId */
  "data-v-47815fba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(406)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(509),
  /* scopeId */
  "data-v-4c6b76d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(437)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  "data-v-fc87a1ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(492),
  /* scopeId */
  "data-v-01c76ed6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(418)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(521),
  /* scopeId */
  "data-v-6fb1e154",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(404)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(506),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(427)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  "data-v-7f82af96",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(403)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(505),
  /* scopeId */
  "data-v-37783270",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(428)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(531),
  /* scopeId */
  "data-v-8865580e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(429)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  "data-v-8bac1080",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(421)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(524),
  /* scopeId */
  "data-v-73d85bbc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(420)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(523),
  /* scopeId */
  "data-v-73482aed",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(422)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(525),
  /* scopeId */
  "data-v-75fb8fec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(414)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(517),
  /* scopeId */
  "data-v-5b3bcd02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(424)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(527),
  /* scopeId */
  "data-v-7c15325a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(400)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(502),
  /* scopeId */
  "data-v-33db9acc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(432)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  "data-v-c367584c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(434)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(539),
  /* scopeId */
  "data-v-dfb2aef6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(407)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(510),
  /* scopeId */
  "data-v-4cb51e45",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(401)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(503),
  /* scopeId */
  "data-v-34cda2b9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(410)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(513),
  /* scopeId */
  "data-v-52d61e8e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(408)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(511),
  /* scopeId */
  "data-v-4d0177ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(433)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  "data-v-c57d4cb6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[276]);


// WEBPACK FOOTER //
// static/js/app.606610c6146fa0c63696.js